import { useState, useEffect, Fragment } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/client";

const CSS = `
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
:root {
  --bg: #f0f4fc; --surface: #ffffff; --surface2: #f4f8ff;
  --border: #c0d0eb; --border2: #d5e3f5;
  --accent: #0284c7; --text: #0d1a36; --text2: #2a4a78; --muted: #6080aa;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  color-scheme: light;
}
body { background: var(--bg); color: var(--text); }
.adm-topbar { position: sticky; top: 0; z-index: 100; height: 52px; display: flex; align-items: center; background: rgba(240,244,252,.92); backdrop-filter: blur(12px); border-bottom: 1px solid var(--border2); }
.adm-back { width: 52px; height: 52px; display: flex; align-items: center; justify-content: center; background: none; border: none; border-right: 1px solid var(--border2); color: var(--text2); cursor: pointer; font-size: 16px; flex-shrink: 0; transition: color .15s, background .15s; }
.adm-back:hover { color: var(--text); background: var(--surface); }
.adm-brand { display: flex; align-items: center; gap: 10px; padding: 0 20px; flex: 1; }
.adm-brand-mark { width: 26px; height: 26px; border-radius: 6px; background: linear-gradient(135deg, #0284c7, #2563eb); display: flex; align-items: center; justify-content: center; font-size: 13px; }
.adm-brand-label { font-size: 14px; font-weight: 600; color: var(--text); }
.adm-avatar { margin-right: 16px; width: 30px; height: 30px; border-radius: 50%; background: linear-gradient(135deg, #2563eb, #7c3aed); display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0; }
.adm-tabs { display: flex; align-items: center; gap: 2px; padding: 0 20px; border-bottom: 1px solid var(--border2); background: var(--surface); overflow-x: auto; }
.adm-tab { padding: 14px 16px; font-size: 13px; font-weight: 500; color: var(--muted); background: none; border: none; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px; transition: color .15s; font-family: inherit; white-space: nowrap; }
.adm-tab:hover { color: var(--text2); }
.adm-tab.active { color: var(--accent); font-weight: 700; border-bottom-color: var(--accent); }
.adm-main { max-width: 1200px; margin: 0 auto; padding: 28px 24px 80px; }
.adm-card { background: var(--surface); border: 1px solid var(--border); border-radius: 10px; padding: 24px; margin-bottom: 14px; box-shadow: 0 1px 2px rgba(13,26,54,.04), 0 4px 12px rgba(13,26,54,.05); }
.adm-card-title { font-size: 14px; font-weight: 600; color: var(--text); margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between; }
.adm-card-desc { font-size: 12px; color: var(--muted); margin: -8px 0 14px; line-height: 1.5; }
.adm-table-wrap { overflow-x: auto; }
.adm-table { width: 100%; border-collapse: collapse; min-width: 700px; }
.adm-table th { font-size: 10px; font-weight: 600; letter-spacing: .07em; text-transform: uppercase; color: var(--muted); padding: 0 12px 10px; text-align: left; border-bottom: 1px solid var(--border2); white-space: nowrap; }
.adm-table td { padding: 11px 12px; font-size: 13px; color: var(--text2); border-bottom: 1px solid var(--border2); vertical-align: middle; }
.adm-table tr:last-child td { border-bottom: none; }
.adm-table tr:hover td { background: var(--surface2); }
.adm-badge { display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px; border-radius: 20px; font-size: 10px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; border: 1px solid; white-space: nowrap; }
.adm-badge-dot { width: 5px; height: 5px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
.adm-action-btn { background: none; border: 1px solid var(--border); border-radius: 6px; padding: 4px 9px; font-size: 11px; color: var(--text2); cursor: pointer; font-family: inherit; transition: border-color .15s, color .15s; margin-right: 4px; white-space: nowrap; }
.adm-action-btn:hover { border-color: var(--accent); color: var(--accent); }
.adm-back-link { display: inline-flex; align-items: center; gap: 6px; background: var(--surface2); border: 1px solid var(--border2); border-radius: 8px; padding: 8px 14px; font-size: 12px; font-weight: 600; color: var(--text2); cursor: pointer; font-family: inherit; transition: border-color .15s, color .15s, background .15s; white-space: nowrap; }
.adm-back-link:hover { border-color: var(--accent); color: var(--accent); background: rgba(2,132,199,.06); }
.adm-action-btn.danger:hover { border-color: #dc2626; color: #dc2626; }
.adm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media(max-width:600px){ .adm-form-grid{ grid-template-columns:1fr; } }
.adm-field { display: flex; flex-direction: column; gap: 6px; }
.adm-label { font-size: 11px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; color: var(--muted); }
.adm-input { background: var(--surface2); border: 1px solid var(--border2); border-radius: 7px; padding: 9px 12px; font-size: 13px; color: var(--text); outline: none; font-family: inherit; transition: border-color .15s; }
.adm-input:focus { border-color: var(--accent); }
.adm-input:disabled { opacity: .5; cursor: not-allowed; background: var(--border2); }
.adm-select { background: var(--surface2); border: 1px solid var(--border2); border-radius: 7px; padding: 9px 12px; font-size: 13px; color: var(--text); outline: none; font-family: inherit; cursor: pointer; }
.adm-submit { margin-top: 16px; padding: 10px 24px; border-radius: 7px; background: linear-gradient(135deg, #0284c7, #2563eb); border: none; color: #fff; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit; transition: opacity .15s, box-shadow .15s; box-shadow: 0 2px 8px rgba(2,132,199,.25); }
.adm-submit:hover { opacity: .9; box-shadow: 0 4px 14px rgba(2,132,199,.35); }
.adm-submit:disabled { opacity: .5; cursor: not-allowed; }
/* Same footprint as .adm-submit (same padding/font-size/radius) so a primary
   and secondary action sit as a matched pair in a button row — outlined
   instead of filled, for "Back", "Cancel", "Back to List", "Save Progress". */
.adm-btn-secondary { padding: 10px 24px; border-radius: 7px; background: none; border: 1.5px solid var(--border); color: var(--text2); font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; transition: border-color .15s, color .15s, background .15s; white-space: nowrap; }
.adm-btn-secondary:hover { border-color: var(--accent); color: var(--accent); background: rgba(2,132,199,.06); }
.adm-btn-secondary:disabled { opacity: .5; cursor: not-allowed; }
.adm-action-btn:disabled { opacity: .5; cursor: not-allowed; }
.adm-section-btn { background: none; border: 1px solid var(--accent); border-radius: 7px; padding: 7px 14px; font-size: 12px; color: var(--accent); cursor: pointer; font-family: inherit; font-weight: 600; transition: background .15s; }
.adm-section-btn:hover { background: rgba(2,132,199,.1); }
.adm-icon-btn { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; background: none; border: 1px solid var(--border); border-radius: 6px; color: var(--text2); cursor: pointer; transition: border-color .15s, color .15s, background .15s; }
.adm-icon-btn:hover { border-color: var(--accent); color: var(--accent); background: var(--surface2); }
.adm-icon-btn.danger:hover { border-color: #dc2626; color: #dc2626; background: rgba(220,38,38,.06); }
.adm-row-actions { display: flex; gap: 6px; }
.adm-inline-form { background: var(--surface2); border: 1px solid var(--border); border-radius: 10px; padding: 24px; margin-bottom: 14px; box-shadow: 0 1px 2px rgba(13,26,54,.04), 0 4px 12px rgba(13,26,54,.05); }
.adm-inline-form-title { font-size: 13px; font-weight: 600; color: var(--text); margin-bottom: 14px; }
.adm-fieldset-title { font-size: 12px; font-weight: 700; color: var(--accent); margin: 18px 0 10px; text-transform: uppercase; letter-spacing: .04em; }
.adm-fieldset-title:first-child { margin-top: 0; }
.adm-error { padding: 10px 14px; border-radius: 7px; background: rgba(248,113,113,.08); border: 1px solid rgba(248,113,113,.2); color: #dc2626; font-size: 13px; margin-bottom: 14px; }
.adm-warning { padding: 12px 14px; border-radius: 7px; background: rgba(245,158,11,.1); border: 1px solid rgba(245,158,11,.3); color: #b45309; font-size: 13px; margin-bottom: 14px; }
.adm-status-warning { font-size: 12px; color: #b45309; }
/* A transient confirmation (e.g. "Loan created") floats as a toast in the
   corner instead of an inline banner that pushes content down and needs a
   scroll-to-top to be seen — it's always on screen regardless of scroll
   position, and clears itself after a few seconds (see flash()). */
.adm-toast { position: fixed; top: 68px; right: 20px; z-index: 300; padding: 12px 16px; border-radius: 8px;
  background: #ffffff; border: 1px solid rgba(16,185,129,.3); color: #059669; font-size: 13px; font-weight: 500;
  box-shadow: 0 4px 16px rgba(13,26,54,.12), 0 1px 3px rgba(13,26,54,.08); max-width: 360px;
  display: flex; align-items: center; gap: 8px; animation: admToastIn .25s ease-out; }
@keyframes admToastIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
.adm-toast-dot { width: 8px; height: 8px; border-radius: 50%; background: #059669; flex-shrink: 0; }
.adm-num { text-align: right; font-variant-numeric: tabular-nums; }
.adm-spinner-wrap { display: flex; justify-content: center; align-items: center; height: 200px; }
.adm-spinner { width: 32px; height: 32px; border: 3px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: aspin .6s linear infinite; }
@keyframes aspin { to { transform: rotate(360deg); } }
/* Skeleton placeholder for the main employee list's first load — stands in
   the shape of the table that's about to appear, instead of a blank area
   with a spinner. */
.adm-skeleton-bar { height: 13px; border-radius: 4px; background: linear-gradient(90deg, var(--border2) 25%, var(--surface2) 42%, var(--border2) 63%); background-size: 400% 100%; animation: admShimmer 1.4s ease infinite; }
@keyframes admShimmer { 0% { background-position: 100% 50%; } 100% { background-position: 0 50%; } }
.adm-skeleton-row { display: grid; grid-template-columns: 1.4fr 1fr 1fr 1fr .8fr; gap: 20px; align-items: center; padding: 13px 12px; border-bottom: 1px solid var(--border2); }
.adm-empty { font-size: 13px; color: var(--muted); padding: 28px 20px; text-align: center; border: 1px dashed var(--border2); border-radius: 8px; background: var(--surface2); }
.adm-row-lowconf td { background: rgba(245,158,11,.08); }
.adm-upload-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
@media(max-width:600px){ .adm-upload-grid{ grid-template-columns:1fr; } }
.adm-upload-slot { border: 1px dashed var(--border); border-radius: 8px; padding: 14px; }
.adm-upload-slot.filled { border-style: solid; border-color: #059669; }
.adm-confidence { font-size: 11px; font-weight: 700; padding: 2px 6px; border-radius: 10px; }
.adm-confidence.low { background: rgba(245,158,11,.15); color: #b45309; }
.adm-confidence.high { background: rgba(16,185,129,.12); color: #059669; }
`;

const CLASSIFICATION_COLOR = {
  payroll:     { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  non_payroll: { color: "#b45309", bg: "rgba(245,158,11,.1)",  border: "rgba(245,158,11,.25)" },
  offshore:    { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
};
const STATUS_COLOR = {
  draft:      { color: "#6080aa", bg: "rgba(96,128,170,.1)",   border: "rgba(96,128,170,.25)" },
  onboarding: { color: "#0284c7", bg: "rgba(2,132,199,.1)",    border: "rgba(2,132,199,.25)"  },
  active:     { color: "#059669", bg: "rgba(16,185,129,.1)",   border: "rgba(16,185,129,.25)" },
  inactive:   { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  resigned:   { color: "#b45309", bg: "rgba(245,158,11,.1)",   border: "rgba(245,158,11,.25)" },
  terminated: { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  on_hold:    { color: "#6080aa", bg: "rgba(96,128,170,.1)",   border: "rgba(96,128,170,.25)" },
};

// Mirrors Payroll.js's PAYROLL_STATUS_COLOR exactly — duplicated rather
// than cross-imported, same "each page carries its own copy" convention
// already used for the shared CSS block between these two files.
const PAYROLL_HISTORY_STATUS_COLOR = {
  draft:         { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  calculated:    { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  reviewed:      { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
  approved:      { color: "#0284c7", bg: "rgba(2,132,199,.1)",   border: "rgba(2,132,199,.25)" },
  wps_generated: { color: "#b45309", bg: "rgba(180,83,9,.1)",    border: "rgba(180,83,9,.25)" },
  paid:          { color: "#166534", bg: "rgba(22,101,52,.1)",   border: "rgba(22,101,52,.25)" },
};

const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const LEAVE_STATUS_COLOR = {
  active:    { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  cancelled: { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
};

const LOAN_STATUS_COLOR = {
  draft:        { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  active:       { color: "#0284c7", bg: "rgba(2,132,199,.1)",   border: "rgba(2,132,199,.25)"  },
  fully_repaid: { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  cancelled:    { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  closed:       { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
};
const LOAN_DEDUCTION_STATUS_COLOR = {
  confirmed: { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  reversed:  { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
};
const BLANK_LOAN_FORM = {
  loan_type: "loan", purpose: "", other_purpose: "", loan_amount: "",
  entry_date: "", guarantor: "", notes: "",
};
const BLANK_DEDUCTION_FORM = {
  deduction_date: "", deduction_amount: "", source: "salary", payroll_month: "", reference_number: "", remarks: "",
};

const ASSET_STATUS_COLOR = {
  draft:             { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  available:         { color: "#0284c7", bg: "rgba(2,132,199,.1)",   border: "rgba(2,132,199,.25)"  },
  assigned:          { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  under_maintenance: { color: "#b45309", bg: "rgba(180,83,9,.1)",    border: "rgba(180,83,9,.25)"   },
  returned:          { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  lost:              { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  damaged:           { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  retired:           { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
};
const DEACTIVATION_STATUS_COLOR = {
  not_required:       { color: "#6080aa", bg: "rgba(96,128,170,.1)",  border: "rgba(96,128,170,.25)" },
  pending:            { color: "#b45309", bg: "rgba(180,83,9,.1)",    border: "rgba(180,83,9,.25)"   },
  completed:          { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  failed:             { color: "#dc2626", bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.2)" },
  exception_approved: { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
};
const OFFBOARDING_TASK_STATUS_COLOR = {
  pending:            { color: "#b45309", bg: "rgba(180,83,9,.1)",    border: "rgba(180,83,9,.25)"   },
  completed:          { color: "#059669", bg: "rgba(16,185,129,.1)",  border: "rgba(16,185,129,.25)" },
  exception_approved: { color: "#7c3aed", bg: "rgba(124,58,237,.1)",  border: "rgba(124,58,237,.25)" },
};

const BLANK_ASSET_FORM = {
  // No standalone asset_title/category inputs -- the backend derives both
  // from the type-specific fields below (Make/Model for a vehicle,
  // Hardware Category for hardware, etc.) so nothing is typed twice.
  asset_type: "vehicle", current_location: "",
  vehicle: { registration_number: "", chassis_vin: "", make: "", model: "", insurance_provider: "",
             insurance_policy_number: "", insurance_expiry_date: "", registration_expiry_date: "", condition_at_issue: "new" },
  hardware: { hardware_category: "", manufacturer: "", model: "", serial_or_imei: "", condition_at_issue: "new" },
  software: { software_name: "", licence_type: "", vendor: "", assigned_account_email: "", software_start_date: "",
              auto_renewal: false, renewal_date: "", admin_owner: "", sso_managed: false, offboarding_action: "deactivate",
              offboarding_reason: "", offboarding_approver: "", recoverable_licence: true },
};
const BLANK_RELOCATE_FORM = {
  relocation_type: "employee_transfer", to_employee_id: "", to_location: "",
  effective_date: "", reason: "", condition_at_handover: "good", approved_by: "",
};

// Optional (Mandatory=No) fields per the boss's scoping instruction --
// shown on the form disabled, as a placeholder for a future release. No
// state, no validation, excluded from every save payload.
const PLACEHOLDER_FIELDS = {
  common: ["Expected Return Date", "Department / Cost Centre", "Vendor / Supplier", "Purchase / Contract Date",
           "Purchase / Subscription Cost", "Owner / Responsible Department", "Notes"],
  vehicle: ["Model Year", "Colour", "Fuel / Power Type", "Odometer at Issue", "Keys / Cards Issued"],
  hardware: ["Asset Tag", "Hostname / Device Name", "MAC Address", "Operating System",
             "Technical Specifications", "Accessories Issued", "Warranty Expiry Date"],
  software: ["Product / Plan / Edition", "Licence Key / Reference", "Seat / Licence Identifier",
             "Billing Frequency", "Allocated Quantity / Seats", "Admin Portal URL", "Notice Period for Cancellation"],
  relocation: ["Recipient Acknowledgement", "Handover Evidence"],
};

// FRD LV-FR-001/LV-BR-001: eligible for every nationality except Omani.
// Mirrors backend routers/leave.py's is_eligible() exactly (case/whitespace
// -insensitive; blank/unset nationality is treated as eligible, not hidden).
function isEligibleForLeave(nationality) {
  return (nationality || "").trim().toLowerCase() !== "omani";
}

function Badge({ label, type, colorMap }) {
  const c = colorMap[type] || colorMap.draft || Object.values(colorMap)[0];
  return (
    <span className="adm-badge" style={{ color: c.color, background: c.bg, borderColor: c.border }}>
      <span className="adm-badge-dot" />
      {(label || "").replace(/_/g, " ")}
    </span>
  );
}

// Small inline-SVG icons — no new dependency, just replacing the plain
// Unicode arrows (&#8592;, ▼, ▲) that were standing in for real icons.
function IconArrowLeft(props) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 12H5M11 18l-6-6 6-6" />
    </svg>
  );
}
function IconChevron({ open, ...props }) {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
         strokeLinecap="round" strokeLinejoin="round"
         style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s" }} {...props}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}
function IconEye(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
function IconEdit(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5Z" />
    </svg>
  );
}
function IconTrash(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6h16Z" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  );
}

// Oman pinned first (this is an Oman WPS payroll system), rest alphabetical by country name.
const COUNTRY_CODES = [
  { code: "+968", name: "Oman" },
  { code: "+93", name: "Afghanistan" }, { code: "+355", name: "Albania" }, { code: "+213", name: "Algeria" },
  { code: "+1", name: "United States / Canada" }, { code: "+244", name: "Angola" }, { code: "+54", name: "Argentina" },
  { code: "+374", name: "Armenia" }, { code: "+61", name: "Australia" }, { code: "+43", name: "Austria" },
  { code: "+994", name: "Azerbaijan" }, { code: "+973", name: "Bahrain" }, { code: "+880", name: "Bangladesh" },
  { code: "+375", name: "Belarus" }, { code: "+32", name: "Belgium" }, { code: "+501", name: "Belize" },
  { code: "+229", name: "Benin" }, { code: "+975", name: "Bhutan" }, { code: "+591", name: "Bolivia" },
  { code: "+387", name: "Bosnia and Herzegovina" }, { code: "+267", name: "Botswana" }, { code: "+55", name: "Brazil" },
  { code: "+673", name: "Brunei" }, { code: "+359", name: "Bulgaria" }, { code: "+226", name: "Burkina Faso" },
  { code: "+257", name: "Burundi" }, { code: "+855", name: "Cambodia" }, { code: "+237", name: "Cameroon" },
  { code: "+238", name: "Cape Verde" }, { code: "+236", name: "Central African Republic" }, { code: "+235", name: "Chad" },
  { code: "+56", name: "Chile" }, { code: "+86", name: "China" }, { code: "+57", name: "Colombia" },
  { code: "+269", name: "Comoros" }, { code: "+243", name: "Congo (DRC)" }, { code: "+242", name: "Congo (Republic)" },
  { code: "+506", name: "Costa Rica" }, { code: "+385", name: "Croatia" }, { code: "+53", name: "Cuba" },
  { code: "+357", name: "Cyprus" }, { code: "+420", name: "Czech Republic" }, { code: "+45", name: "Denmark" },
  { code: "+253", name: "Djibouti" }, { code: "+593", name: "Ecuador" }, { code: "+20", name: "Egypt" },
  { code: "+503", name: "El Salvador" }, { code: "+291", name: "Eritrea" }, { code: "+372", name: "Estonia" },
  { code: "+251", name: "Ethiopia" }, { code: "+679", name: "Fiji" }, { code: "+358", name: "Finland" },
  { code: "+33", name: "France" }, { code: "+241", name: "Gabon" }, { code: "+220", name: "Gambia" },
  { code: "+995", name: "Georgia" }, { code: "+49", name: "Germany" }, { code: "+233", name: "Ghana" },
  { code: "+30", name: "Greece" }, { code: "+502", name: "Guatemala" }, { code: "+224", name: "Guinea" },
  { code: "+592", name: "Guyana" }, { code: "+509", name: "Haiti" }, { code: "+504", name: "Honduras" },
  { code: "+852", name: "Hong Kong" }, { code: "+36", name: "Hungary" }, { code: "+354", name: "Iceland" },
  { code: "+91", name: "India" }, { code: "+62", name: "Indonesia" }, { code: "+98", name: "Iran" },
  { code: "+964", name: "Iraq" }, { code: "+353", name: "Ireland" }, { code: "+972", name: "Israel" },
  { code: "+39", name: "Italy" }, { code: "+225", name: "Ivory Coast" }, { code: "+81", name: "Japan" },
  { code: "+962", name: "Jordan" }, { code: "+7", name: "Kazakhstan / Russia" }, { code: "+254", name: "Kenya" },
  { code: "+965", name: "Kuwait" }, { code: "+996", name: "Kyrgyzstan" }, { code: "+856", name: "Laos" },
  { code: "+371", name: "Latvia" }, { code: "+961", name: "Lebanon" }, { code: "+266", name: "Lesotho" },
  { code: "+231", name: "Liberia" }, { code: "+218", name: "Libya" }, { code: "+370", name: "Lithuania" },
  { code: "+352", name: "Luxembourg" }, { code: "+853", name: "Macau" }, { code: "+389", name: "Macedonia" },
  { code: "+261", name: "Madagascar" }, { code: "+265", name: "Malawi" }, { code: "+60", name: "Malaysia" },
  { code: "+960", name: "Maldives" }, { code: "+223", name: "Mali" }, { code: "+356", name: "Malta" },
  { code: "+222", name: "Mauritania" }, { code: "+230", name: "Mauritius" }, { code: "+52", name: "Mexico" },
  { code: "+373", name: "Moldova" }, { code: "+976", name: "Mongolia" }, { code: "+382", name: "Montenegro" },
  { code: "+212", name: "Morocco" }, { code: "+258", name: "Mozambique" }, { code: "+95", name: "Myanmar" },
  { code: "+264", name: "Namibia" }, { code: "+977", name: "Nepal" }, { code: "+31", name: "Netherlands" },
  { code: "+64", name: "New Zealand" }, { code: "+505", name: "Nicaragua" }, { code: "+227", name: "Niger" },
  { code: "+234", name: "Nigeria" }, { code: "+850", name: "North Korea" }, { code: "+47", name: "Norway" },
  { code: "+92", name: "Pakistan" }, { code: "+970", name: "Palestine" }, { code: "+507", name: "Panama" },
  { code: "+675", name: "Papua New Guinea" }, { code: "+595", name: "Paraguay" }, { code: "+51", name: "Peru" },
  { code: "+63", name: "Philippines" }, { code: "+48", name: "Poland" }, { code: "+351", name: "Portugal" },
  { code: "+974", name: "Qatar" }, { code: "+40", name: "Romania" }, { code: "+250", name: "Rwanda" },
  { code: "+966", name: "Saudi Arabia" }, { code: "+221", name: "Senegal" }, { code: "+381", name: "Serbia" },
  { code: "+232", name: "Sierra Leone" }, { code: "+65", name: "Singapore" }, { code: "+421", name: "Slovakia" },
  { code: "+386", name: "Slovenia" }, { code: "+252", name: "Somalia" }, { code: "+27", name: "South Africa" },
  { code: "+82", name: "South Korea" }, { code: "+211", name: "South Sudan" }, { code: "+34", name: "Spain" },
  { code: "+94", name: "Sri Lanka" }, { code: "+249", name: "Sudan" }, { code: "+597", name: "Suriname" },
  { code: "+268", name: "Eswatini" }, { code: "+46", name: "Sweden" }, { code: "+41", name: "Switzerland" },
  { code: "+963", name: "Syria" }, { code: "+886", name: "Taiwan" }, { code: "+992", name: "Tajikistan" },
  { code: "+255", name: "Tanzania" }, { code: "+66", name: "Thailand" }, { code: "+228", name: "Togo" },
  { code: "+216", name: "Tunisia" }, { code: "+90", name: "Turkey" }, { code: "+993", name: "Turkmenistan" },
  { code: "+256", name: "Uganda" }, { code: "+380", name: "Ukraine" }, { code: "+971", name: "United Arab Emirates" },
  { code: "+44", name: "United Kingdom" }, { code: "+598", name: "Uruguay" }, { code: "+998", name: "Uzbekistan" },
  { code: "+58", name: "Venezuela" }, { code: "+84", name: "Vietnam" }, { code: "+967", name: "Yemen" },
  { code: "+260", name: "Zambia" }, { code: "+263", name: "Zimbabwe" },
];

// ID-type dropdown: selecting a type reveals only the image slot(s) that
// type actually needs (Civil ID needs Front + Back; everything else is one
// image). This is the reusable "ID management" selector — the same picker
// is used for the initial Add Employee upload step and for adding/managing
// documents on an existing employee from the Edit screen.
// These 4 stay fixed in code since they're tied to real AI-extraction
// prompts. Every other document type (Contract, Certificate, License, any
// org-added custom type) is fetched from the backend and extensible from
// the dropdown itself — see attachTypes/addDocumentType below.
const FIXED_ID_TYPE_OPTIONS = [
  { key: "civil_id", label: "Civil ID (Oman)", ocr: true, parts: [
      { type: "civil_id_front", label: "Civil ID — Front" },
      { type: "civil_id_back", label: "Civil ID — Back" },
    ] },
  { key: "passport", label: "Passport", ocr: true, parts: [{ type: "passport", label: "Passport" }] },
  { key: "foreign_id", label: "Foreign ID", ocr: true, parts: [{ type: "foreign_id", label: "Foreign ID" }] },
  { key: "residence_permit", label: "Residence Permit", ocr: true, parts: [{ type: "residence_permit", label: "Residence Permit" }] },
];
const ADD_NEW_DOC_TYPE = "__add_new_doc_type__";
const CONFIDENCE_THRESHOLD = 70;

const EMERGENCY_KEYS = [
  "emergency_contact_name", "emergency_contact_relationship",
  "emergency_contact_mobile_country_code", "emergency_contact_mobile_number",
  "emergency_contact_alternate_mobile_country_code", "emergency_contact_alternate_mobile_number",
  "emergency_contact_email", "emergency_contact_country", "emergency_contact_address", "emergency_contact_notes",
];

const BLANK_EMPLOYEE = {
  classification: "", full_name: "", full_name_arabic: "",
  civil_id_number: "", passport_number: "", foreign_id_number: "", primary_id_type: "",
  nationality: "", date_of_birth: "", gender: "", country_of_residence: "", marital_status: "",
  primary_mobile_country_code: "", primary_mobile_number: "",
  secondary_mobile_country_code: "", secondary_mobile_number: "",
  personal_email: "", company_email: "", residential_address: "", permanent_address: "",
  city: "", country: "", postal_code: "",
  employment_status: "draft", employee_type: "", joining_date: "", department: "", designation: "",
  branch_location: "", reporting_manager_id: "",
  contract_start_date: "", contract_end_date: "", probation_end_date: "",
  last_working_date: "", remarks: "",
  ...Object.fromEntries(EMERGENCY_KEYS.map(k => [k, ""])),
};

function buildCreateBody(form, confirmDuplicate) {
  const body = { ...form };
  EMERGENCY_KEYS.forEach(k => delete body[k]);
  Object.keys(body).forEach(k => { if (body[k] === "") body[k] = null; });
  if (form.emergency_contact_name && form.emergency_contact_relationship) {
    body.emergency_contact = {
      name: form.emergency_contact_name,
      relationship: form.emergency_contact_relationship,
      primary_mobile_country_code: form.emergency_contact_mobile_country_code || null,
      primary_mobile_number: form.emergency_contact_mobile_number || null,
      alternate_mobile_country_code: form.emergency_contact_alternate_mobile_country_code || null,
      alternate_mobile_number: form.emergency_contact_alternate_mobile_number || null,
      email: form.emergency_contact_email || null,
      country: form.emergency_contact_country || null,
      address: form.emergency_contact_address || null,
      notes: form.emergency_contact_notes || null,
    };
  }
  body.confirm_duplicate = !!confirmDuplicate;
  return body;
}

export default function Employees() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const initials = (user?.name || "H").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();

  const [employees, setEmployees] = useState([]);
  const [enums, setEnums] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  // AI natural-language search — same pattern as the Business Card Agent's
  // /bizcard/search/ai. aiResults is null while showing the full directory,
  // and an array (possibly empty) once a search has actually run.
  const [aiQuery, setAiQuery] = useState("");
  const [aiSearching, setAiSearching] = useState(false);
  const [aiResults, setAiResults] = useState(null);

  const [view, setView] = useState("list"); // "list" | "add" | "edit" | "view"
  const readOnly = view === "view"; // true only for the read-only profile screen -- referenced by every render*Section below via closure
  const [newEmp, setNewEmp] = useState({ ...BLANK_EMPLOYEE });
  const [editingEmp, setEditingEmp] = useState(null);
  const [dupWarning, setDupWarning] = useState(null); // { duplicates, mode: "add"|"edit" }

  // Document upload + OCR review (Milestone 3)
  const [draftSessionId, setDraftSessionId] = useState(null);
  const [uploadedDocs, setUploadedDocs] = useState([]); // [{document_id, document_type, ocr_status, fields:[...]}]
  const [extractingSlot, setExtractingSlot] = useState(null); // document_type currently uploading
  const [crossCheckWarning, setCrossCheckWarning] = useState(null);
  const [formDocs, setFormDocs] = useState([]); // documents shown inside the Add/Edit form (list-endpoint shape)
  const [selectedIdType, setSelectedIdType] = useState("");
  const [editingFieldKey, setEditingFieldKey] = useState(null); // `${documentId}:${fieldName}` currently being hand-edited
  const [editingFieldValue, setEditingFieldValue] = useState("");
  const [attachTypes, setAttachTypes] = useState([]); // [{value,label}] — built-ins + org-added custom document types
  const [addingNewType, setAddingNewType] = useState(false);
  const [newTypeLabel, setNewTypeLabel] = useState("");
  const [savingNewType, setSavingNewType] = useState(false);
  const [newTypeTarget, setNewTypeTarget] = useState(null); // which picker opened "+ Add new document type…": "manual" | "editType"
  const [collapsedDocIds, setCollapsedDocIds] = useState([]); // document ids currently minimized
  const [uploaderOpen, setUploaderOpen] = useState(true); // whether the ID Type picker is expanded
  const [editingTypeDocId, setEditingTypeDocId] = useState(null); // which uploaded document's type is being corrected
  const [editingTypeValue, setEditingTypeValue] = useState("");
  const [savingType, setSavingType] = useState(false);
  const [acceptingAllDocId, setAcceptingAllDocId] = useState(null); // document id currently running Accept All
  const [formTab, setFormTab] = useState("documents"); // active tab inside the Add/Edit Employee form

  // Banking (Milestone 5)
  const [bankAccount, setBankAccount] = useState(null); // masked, as returned by the API
  const [bankForm, setBankForm] = useState({}); // account_number/iban stay blank unless the user is changing them
  const [savingBank, setSavingBank] = useState(false);
  const [bankJustSaved, setBankJustSaved] = useState(false);
  const [bankRevealed, setBankRevealed] = useState(false);

  // Salary (Milestone 5)
  const [salaryStructures, setSalaryStructures] = useState([]);
  const [payrollHistory, setPayrollHistory] = useState([]);
  const [expandedHistoryEntryId, setExpandedHistoryEntryId] = useState(null);
  const [salaryComponentOptions, setSalaryComponentOptions] = useState([]);

  // Leave Management (Annual + Casual — non-Omani employees only)
  const [leaveSummary, setLeaveSummary] = useState(null);
  const [leaveEntries, setLeaveEntries] = useState([]);
  const [showAddLeaveForm, setShowAddLeaveForm] = useState(false);
  const [editingLeaveEntryId, setEditingLeaveEntryId] = useState(null);
  const [newLeaveType, setNewLeaveType] = useState("annual");
  const [newLeaveStart, setNewLeaveStart] = useState("");
  const [newLeaveEnd, setNewLeaveEnd] = useState("");
  const [newLeaveDate, setNewLeaveDate] = useState("");
  const [newLeaveDuration, setNewLeaveDuration] = useState("full_day");
  const [newLeaveRemarks, setNewLeaveRemarks] = useState("");
  const [savingLeave, setSavingLeave] = useState(false);

  // Employee Loans (Milestone 6) — no eligibility gate, every employee qualifies.
  const [loans, setLoans] = useState([]);
  const [showAddLoanForm, setShowAddLoanForm] = useState(false);
  const [newLoanForm, setNewLoanForm] = useState({ ...BLANK_LOAN_FORM });
  const [savingLoan, setSavingLoan] = useState(false);
  const [expandedLoanId, setExpandedLoanId] = useState(null);
  const [loanDeductions, setLoanDeductions] = useState([]);
  const [loanDocuments, setLoanDocuments] = useState([]);
  const [loanDocumentTitles, setLoanDocumentTitles] = useState([]);
  const [planInstruction, setPlanInstruction] = useState("");
  const [planDraft, setPlanDraft] = useState(null); // AI-generated fields, editable before Confirm
  const [generatingPlan, setGeneratingPlan] = useState(false);
  const [confirmingPlan, setConfirmingPlan] = useState(false);
  const [showAddDeductionForm, setShowAddDeductionForm] = useState(false);
  const [newDeductionForm, setNewDeductionForm] = useState({ ...BLANK_DEDUCTION_FORM });
  const [savingDeduction, setSavingDeduction] = useState(false);
  const [newDocTitle, setNewDocTitle] = useState("");
  const [uploadingDoc, setUploadingDoc] = useState(false);

  // Asset Management (Milestone 8) — no eligibility gate.
  const [assets, setAssets] = useState([]);
  const [showAddAssetForm, setShowAddAssetForm] = useState(false);
  const [editingAssetId, setEditingAssetId] = useState(null); // null = adding a new asset, else editing this one
  const [newAssetForm, setNewAssetForm] = useState({ ...BLANK_ASSET_FORM });
  const [savingAsset, setSavingAsset] = useState(false);
  const [readingMulkiya, setReadingMulkiya] = useState(false);
  const [mulkiyaInputKey, setMulkiyaInputKey] = useState(0);
  const [showAssetPlaceholders, setShowAssetPlaceholders] = useState(false);
  const [expandedAssetId, setExpandedAssetId] = useState(null);
  const [assetRelocations, setAssetRelocations] = useState([]);
  const [assetDocuments, setAssetDocuments] = useState([]);
  const [assetDocumentTitles, setAssetDocumentTitles] = useState([]);
  const [newAssetDocTitle, setNewAssetDocTitle] = useState("");
  const [uploadingAssetDoc, setUploadingAssetDoc] = useState(false);
  const [showRelocateForm, setShowRelocateForm] = useState(false);
  const [relocateForm, setRelocateForm] = useState({ ...BLANK_RELOCATE_FORM });
  const [savingRelocate, setSavingRelocate] = useState(false);
  const [showDeactivateForm, setShowDeactivateForm] = useState(false);
  const [deactivateEvidence, setDeactivateEvidence] = useState("");
  const [savingDeactivate, setSavingDeactivate] = useState(false);
  const [offboardingClearance, setOffboardingClearance] = useState(null);
  const [showStartOffboarding, setShowStartOffboarding] = useState(false);
  const [offboardingLastDay, setOffboardingLastDay] = useState("");
  const [savingOffboarding, setSavingOffboarding] = useState(false);

  const [showAddSalaryForm, setShowAddSalaryForm] = useState(false);
  const [editingSalaryStructureId, setEditingSalaryStructureId] = useState(null); // null = adding a new dated version; set = correcting an existing (never-yet-used) one in place
  const [newSalaryEffectiveFrom, setNewSalaryEffectiveFrom] = useState("");
  const [newSalaryComponents, setNewSalaryComponents] = useState({}); // { component_type: amountString }
  const [selectedSalaryComponentType, setSelectedSalaryComponentType] = useState("");
  const [newSalaryDeductionApplicable, setNewSalaryDeductionApplicable] = useState(true);
  const [newSalaryDeductionPct, setNewSalaryDeductionPct] = useState("");
  const [newSalaryDeductionBase, setNewSalaryDeductionBase] = useState("basic_salary");
  const [newSalaryAdditionalDeduction, setNewSalaryAdditionalDeduction] = useState("");
  const [newSalaryRemarks, setNewSalaryRemarks] = useState("");
  const [savingSalary, setSavingSalary] = useState(false);
  const [salaryJustSaved, setSalaryJustSaved] = useState(false);
  const [pullingSalaryFromContract, setPullingSalaryFromContract] = useState(false);
  const [addingNewSalaryComponentType, setAddingNewSalaryComponentType] = useState(false);
  const [newSalaryComponentTypeLabel, setNewSalaryComponentTypeLabel] = useState("");
  const [savingNewSalaryComponentType, setSavingNewSalaryComponentType] = useState(false);
  const [savingEmployee, setSavingEmployee] = useState(false); // Create Employee / Save Changes in flight

  const toggleDocCollapsed = (docId) => {
    setCollapsedDocIds(prev => prev.includes(docId) ? prev.filter(id => id !== docId) : [...prev, docId]);
  };

  const load = () => {
    setLoading(true);
    Promise.all([api.get("/employees"), api.get("/employees/meta/enums")])
      .then(([e, en]) => { setEmployees(e.data); setEnums(en.data); })
      .catch(() => setError("Failed to load employees — check you have HR/Admin access."))
      .finally(() => setLoading(false));
  };

  const loadAttachTypes = () => {
    api.get("/employee-documents/document-types")
      .then(r => setAttachTypes(r.data.attach_types || []))
      .catch(() => {});
  };

  const loadSalaryComponentOptions = () => {
    api.get("/employees/salary-component-options")
      .then(r => setSalaryComponentOptions(r.data.components || []))
      .catch(() => {});
  };

  useEffect(() => { load(); loadAttachTypes(); loadSalaryComponentOptions(); }, []);

  // Deep-link: other HRMS pages (e.g. Data Quality) link here as
  // /hrms/employees?edit=<id> to open a specific record straight in Edit
  // mode. Runs once the employee list is in hand; clears the param after so
  // a later "Back to List" doesn't bounce back into Edit.
  useEffect(() => {
    const editId = searchParams.get("edit");
    if (!editId || employees.length === 0) return;
    const target = employees.find(e => String(e.id) === String(editId));
    if (target) startEdit(target);
    setSearchParams({}, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees, searchParams]);

  // This form is long — a message set anywhere (success or error) needs to
  // actually be seen, not silently appear off-screen above whatever section
  // the user is currently scrolled down to.
  useEffect(() => { if (error) window.scrollTo({ top: 0, behavior: "smooth" }); }, [error]);

  const loadBankAccount = (employeeId) => {
    api.get(`/employees/${employeeId}/bank-account`)
      .then(r => { setBankAccount(r.data); setBankForm({}); setBankRevealed(false); })
      .catch(() => { setBankAccount(null); setBankForm({}); });
  };

  const loadSalaryStructures = (employeeId) => {
    api.get(`/employees/${employeeId}/salary-structures`)
      .then(r => setSalaryStructures(r.data || []))
      .catch(() => setSalaryStructures([]));
  };

  const loadPayrollHistory = (employeeId) => {
    api.get(`/reports/employees/${employeeId}/payroll-history`)
      .then(r => setPayrollHistory(r.data.history || []))
      .catch(() => setPayrollHistory([]));
  };

  const loadLeaveData = (employeeId) => {
    api.get(`/leave/employees/${employeeId}/summary`)
      .then(r => setLeaveSummary(r.data))
      .catch(() => setLeaveSummary(null));
    api.get(`/leave/employees/${employeeId}/entries`)
      .then(r => setLeaveEntries(r.data.entries || []))
      .catch(() => setLeaveEntries([]));
  };

  const resetNewLeaveForm = () => {
    setEditingLeaveEntryId(null);
    setNewLeaveType("annual");
    setNewLeaveStart(""); setNewLeaveEnd("");
    setNewLeaveDate(""); setNewLeaveDuration("full_day");
    setNewLeaveRemarks("");
  };

  const startEditLeaveEntry = (entry) => {
    setEditingLeaveEntryId(entry.id);
    setNewLeaveType(entry.leave_type);
    setNewLeaveStart(entry.start_date || "");
    setNewLeaveEnd(entry.end_date || "");
    setNewLeaveDate(entry.leave_date || "");
    setNewLeaveDuration(entry.duration || "full_day");
    setNewLeaveRemarks(entry.remarks || "");
    setShowAddLeaveForm(true);
  };

  const saveLeaveEntry = async (employeeId) => {
    setSavingLeave(true);
    setError("");
    try {
      if (newLeaveType === "annual") {
        if (!newLeaveStart || !newLeaveEnd) { setError("Start Date and End Date are required for Annual Leave."); return; }
        const body = { leave_type: "annual", start_date: newLeaveStart, end_date: newLeaveEnd, remarks: newLeaveRemarks || null };
        if (editingLeaveEntryId) await api.patch(`/leave/entries/${editingLeaveEntryId}`, body);
        else await api.post(`/leave/employees/${employeeId}/entries`, body);
      } else {
        if (!newLeaveDate) { setError("Leave Date is required for Casual Leave."); return; }
        const body = { leave_type: "casual", leave_date: newLeaveDate, duration: newLeaveDuration, remarks: newLeaveRemarks || null };
        if (editingLeaveEntryId) await api.patch(`/leave/entries/${editingLeaveEntryId}`, body);
        else await api.post(`/leave/employees/${employeeId}/entries`, body);
      }
      loadLeaveData(employeeId);
      resetNewLeaveForm();
      setShowAddLeaveForm(false);
      flash("Leave entry saved.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to save the leave entry.");
    } finally {
      setSavingLeave(false);
    }
  };

  const cancelLeaveEntry = async (entryId, employeeId) => {
    if (!window.confirm("Cancel this leave entry? It stays on record but is no longer counted as active.")) return;
    try {
      await api.post(`/leave/entries/${entryId}/cancel`);
      loadLeaveData(employeeId);
      flash("Leave entry cancelled.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to cancel the leave entry.");
    }
  };

  // ── Employee Loans (Milestone 6) ─────────────────────────────

  const loadLoansData = (employeeId) => {
    api.get(`/loans/employees/${employeeId}/loans`)
      .then(r => setLoans(r.data.loans || []))
      .catch(() => setLoans([]));
  };

  const loadLoanDocumentTitles = () => {
    api.get("/loans/documents/titles")
      .then(r => setLoanDocumentTitles(r.data.titles || []))
      .catch(() => {});
  };

  const resetNewLoanForm = () => setNewLoanForm({ ...BLANK_LOAN_FORM });

  const saveLoan = async (employeeId) => {
    if (!newLoanForm.purpose) { setError("Please select a Purpose."); return; }
    if (newLoanForm.purpose === "others" && !newLoanForm.other_purpose.trim()) {
      setError("Other Purpose is required when Purpose is 'Others'."); return;
    }
    if (!newLoanForm.loan_amount || Number(newLoanForm.loan_amount) <= 0) {
      setError("Loan Amount must be greater than zero."); return;
    }
    setSavingLoan(true);
    setError("");
    try {
      const body = { ...newLoanForm, loan_amount: Number(newLoanForm.loan_amount) };
      if (!body.entry_date) delete body.entry_date;
      await api.post(`/loans/employees/${employeeId}/loans`, body);
      loadLoansData(employeeId);
      resetNewLoanForm();
      setShowAddLoanForm(false);
      flash("Loan created.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to create the loan.");
    } finally {
      setSavingLoan(false);
    }
  };

  const toggleExpandLoan = (loan) => {
    if (expandedLoanId === loan.id) {
      setExpandedLoanId(null);
      return;
    }
    setExpandedLoanId(loan.id);
    setPlanInstruction(loan.repayment_instruction || "");
    setPlanDraft(null);
    setShowAddDeductionForm(false);
    setNewDeductionForm({ ...BLANK_DEDUCTION_FORM });
    api.get(`/loans/${loan.id}/deductions`).then(r => setLoanDeductions(r.data.deductions || [])).catch(() => setLoanDeductions([]));
    api.get(`/loans/${loan.id}/documents`).then(r => setLoanDocuments(r.data.documents || [])).catch(() => setLoanDocuments([]));
    if (loanDocumentTitles.length === 0) loadLoanDocumentTitles();
  };

  const generatePlan = async (loanId, employeeId) => {
    if (!planInstruction.trim()) { setError("Enter a repayment instruction first."); return; }
    setGeneratingPlan(true);
    setError("");
    try {
      const res = await api.post(`/loans/${loanId}/repayment-plan/generate`, { instruction: planInstruction });
      setPlanDraft(res.data.fields);
      loadLoansData(employeeId);
      flash("Plan generated — review the fields below, then confirm.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to generate a repayment plan from this instruction.");
    } finally {
      setGeneratingPlan(false);
    }
  };

  const confirmPlan = async (loanId, employeeId) => {
    if (!planDraft?.repayment_method) { setError("Repayment Method is required to confirm the plan."); return; }
    setConfirmingPlan(true);
    setError("");
    try {
      const body = {
        repayment_method: planDraft.repayment_method,
        instalment_amount: planDraft.instalment_amount ? Number(planDraft.instalment_amount) : null,
        frequency: planDraft.frequency || null,
        plan_start_date: planDraft.plan_start_date || null,
        num_instalments: planDraft.num_instalments ? parseInt(planDraft.num_instalments, 10) : null,
        expected_completion_date: planDraft.expected_completion_date || null,
        final_instalment_amount: planDraft.final_instalment_amount ? Number(planDraft.final_instalment_amount) : null,
        special_instructions: planDraft.special_instructions || null,
      };
      await api.post(`/loans/${loanId}/repayment-plan/confirm`, body);
      loadLoansData(employeeId);
      setPlanDraft(null);
      flash("Repayment plan confirmed — loan is now Active.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to confirm the repayment plan.");
    } finally {
      setConfirmingPlan(false);
    }
  };

  const recordDeduction = async (loanId, employeeId) => {
    if (!newDeductionForm.deduction_date || !newDeductionForm.deduction_amount) {
      setError("Deduction Date and Amount are required."); return;
    }
    if (newDeductionForm.source === "salary" && !newDeductionForm.payroll_month.trim()) {
      setError("Payroll Month is required when Source is Salary."); return;
    }
    setSavingDeduction(true);
    setError("");
    try {
      const body = { ...newDeductionForm, deduction_amount: Number(newDeductionForm.deduction_amount) };
      await api.post(`/loans/${loanId}/deductions`, body);
      api.get(`/loans/${loanId}/deductions`).then(r => setLoanDeductions(r.data.deductions || []));
      loadLoansData(employeeId);
      setNewDeductionForm({ ...BLANK_DEDUCTION_FORM });
      setShowAddDeductionForm(false);
      flash("Deduction recorded.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to record the deduction.");
    } finally {
      setSavingDeduction(false);
    }
  };

  const reverseDeduction = async (loanId, deductionId, employeeId) => {
    const remarks = window.prompt("Reason for reversing this deduction (required):");
    if (!remarks || !remarks.trim()) return;
    try {
      await api.post(`/loans/${loanId}/deductions/${deductionId}/reverse`, { remarks });
      api.get(`/loans/${loanId}/deductions`).then(r => setLoanDeductions(r.data.deductions || []));
      loadLoansData(employeeId);
      flash("Deduction reversed.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to reverse the deduction.");
    }
  };

  const uploadLoanDocument = async (loanId, file) => {
    const title = (newDocTitle || "").trim();
    if (!title) { setError("Please choose or enter a document title first."); return; }
    setUploadingDoc(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("title", title);
      await api.post(`/loans/${loanId}/documents`, fd);
      api.get(`/loans/${loanId}/documents`).then(r => setLoanDocuments(r.data.documents || []));
      loadLoanDocumentTitles();
      setNewDocTitle("");
      flash("Document uploaded.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to upload this document.");
    } finally {
      setUploadingDoc(false);
    }
  };

  const viewLoanDocument = async (documentId) => {
    try {
      const res = await api.get(`/loans/documents/${documentId}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
    } catch {
      setError("Could not load this document.");
    }
  };

  const deleteLoanDocument = async (loanId, documentId) => {
    if (!window.confirm("Remove this document?")) return;
    try {
      await api.delete(`/loans/documents/${documentId}`);
      api.get(`/loans/${loanId}/documents`).then(r => setLoanDocuments(r.data.documents || []));
      flash("Document removed.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to remove this document.");
    }
  };

  const closeLoan = async (loanId, employeeId) => {
    if (!window.confirm("Close this loan? This marks it as finished and locks it from further edits.")) return;
    try {
      await api.post(`/loans/${loanId}/close`);
      loadLoansData(employeeId);
      flash("Loan closed.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to close this loan.");
    }
  };

  const cancelLoan = async (loanId, employeeId) => {
    if (!window.confirm("Cancel this loan?")) return;
    try {
      await api.post(`/loans/${loanId}/cancel`);
      loadLoansData(employeeId);
      flash("Loan cancelled.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to cancel this loan.");
    }
  };

  // ── Asset Management (Milestone 8) ───────────────────────────

  const loadAssetsData = (employeeId) => {
    api.get(`/assets/employees/${employeeId}/assets`)
      .then(r => setAssets(r.data.assets || []))
      .catch(() => setAssets([]));
  };

  const resetNewAssetForm = () => { setNewAssetForm({ ...BLANK_ASSET_FORM }); setMulkiyaInputKey(k => k + 1); setEditingAssetId(null); };

  // Maps a serialized asset (the GET/list shape) back into newAssetForm's
  // write shape and opens the same Add Asset form in edit mode -- PATCH
  // /assets/{id} already supported every field this form collects, so
  // this reuses that form instead of building a second one.
  const startEditAsset = (asset) => {
    setEditingAssetId(asset.id);
    setNewAssetForm({
      asset_type: asset.asset_type,
      current_location: asset.current_location || "",
      vehicle: {
        registration_number: asset.registration_number || "", chassis_vin: asset.chassis_vin || "",
        make: asset.make || "", model: asset.asset_type === "vehicle" ? (asset.model || "") : "",
        insurance_provider: asset.insurance_provider || "", insurance_policy_number: asset.insurance_policy_number || "",
        insurance_expiry_date: asset.insurance_expiry_date || "", registration_expiry_date: asset.registration_expiry_date || "",
        condition_at_issue: asset.condition_at_issue || "new",
      },
      hardware: {
        hardware_category: asset.hardware_category || "", manufacturer: asset.manufacturer || "",
        model: asset.asset_type === "hardware" ? (asset.model || "") : "",
        serial_or_imei: asset.serial_or_imei || "", condition_at_issue: asset.condition_at_issue || "new",
      },
      software: {
        software_name: asset.software_name || "", licence_type: asset.licence_type || "", vendor: asset.vendor || "",
        assigned_account_email: asset.assigned_account_email || "", software_start_date: asset.software_start_date || "",
        auto_renewal: !!asset.auto_renewal, renewal_date: asset.renewal_date || "", admin_owner: asset.admin_owner || "",
        sso_managed: !!asset.sso_managed, offboarding_action: asset.offboarding_action || "deactivate",
        offboarding_reason: asset.offboarding_reason || "", offboarding_approver: asset.offboarding_approver || "",
        recoverable_licence: asset.recoverable_licence !== false,
      },
    });
    setExpandedAssetId(null); // collapse any open row-details panel so the edit form is the clear focus
    setShowAddAssetForm(true);
  };

  const deleteAsset = async (asset) => {
    if (!window.confirm(`Delete "${asset.asset_title}" (${asset.asset_code})? This cannot be undone.`)) return;
    try {
      await api.delete(`/assets/${asset.id}`);
      setAssets(prev => prev.filter(a => a.id !== asset.id));
      if (expandedAssetId === asset.id) setExpandedAssetId(null);
      flash("Asset deleted.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to delete this asset.");
    }
  };

  // Reads a just-chosen Mulkiya and pre-fills the Vehicle Details fields --
  // nothing is saved by this call, so a bad/failed read never blocks
  // manually filling the fields in instead (same contract as Company
  // Documents' OCR-then-confirm flow).
  const handleMulkiyaChosen = async (chosenFile) => {
    if (!chosenFile) return;
    setReadingMulkiya(true);
    try {
      const fd = new FormData();
      fd.append("file", chosenFile);
      const res = await api.post("/assets/ocr-vehicle-document", fd);
      setNewAssetForm(p => ({
        ...p,
        vehicle: {
          ...p.vehicle,
          registration_number: res.data.registration_number || p.vehicle.registration_number,
          chassis_vin: res.data.chassis_vin || p.vehicle.chassis_vin,
          make: res.data.make || p.vehicle.make,
          model: res.data.model || p.vehicle.model,
          registration_expiry_date: res.data.registration_expiry_date || p.vehicle.registration_expiry_date,
        },
      }));
    } catch {
      // OCR failing here is never an error the user needs to see -- manual entry always works.
    } finally {
      setReadingMulkiya(false);
    }
  };

  const saveAsset = async (employeeId) => {
    if (["vehicle", "hardware"].includes(newAssetForm.asset_type) && !newAssetForm.current_location.trim()) {
      setError("Current Location is required for Vehicle and Hardware assets."); return;
    }
    setSavingAsset(true);
    setError("");
    try {
      const body = {
        asset_type: newAssetForm.asset_type, current_location: newAssetForm.current_location || null,
      };
      if (newAssetForm.asset_type === "vehicle") body.vehicle = newAssetForm.vehicle;
      if (newAssetForm.asset_type === "hardware") body.hardware = newAssetForm.hardware;
      if (newAssetForm.asset_type === "software") body.software = newAssetForm.software;
      if (editingAssetId) {
        await api.patch(`/assets/${editingAssetId}`, body);
        flash("Asset updated.", { scroll: false });
      } else {
        await api.post(`/assets/employees/${employeeId}/assets`, body);
        flash("Asset created.", { scroll: false });
      }
      loadAssetsData(employeeId);
      resetNewAssetForm();
      setShowAddAssetForm(false);
    } catch (e) {
      setError(e.response?.data?.detail || `Failed to ${editingAssetId ? "update" : "create"} this asset.`);
    } finally {
      setSavingAsset(false);
    }
  };

  const toggleExpandAsset = (asset) => {
    if (expandedAssetId === asset.id) {
      setExpandedAssetId(null);
      return;
    }
    setExpandedAssetId(asset.id);
    setShowRelocateForm(false);
    setRelocateForm({ ...BLANK_RELOCATE_FORM });
    setShowDeactivateForm(false);
    setDeactivateEvidence("");
    api.get(`/assets/${asset.id}/documents`).then(r => setAssetDocuments(r.data.documents || [])).catch(() => setAssetDocuments([]));
    api.get(`/assets/${asset.id}/documents/titles`).then(r => setAssetDocumentTitles(r.data.titles || [])).catch(() => setAssetDocumentTitles([]));
    if (["vehicle", "hardware"].includes(asset.asset_type)) {
      api.get(`/assets/${asset.id}/relocations`).then(r => setAssetRelocations(r.data.relocations || [])).catch(() => setAssetRelocations([]));
    } else {
      setAssetRelocations([]);
    }
  };

  const relocateAsset = async (assetId, employeeId) => {
    if (!relocateForm.effective_date || !relocateForm.reason.trim()) {
      setError("Effective Date and Reason are required."); return;
    }
    if (relocateForm.relocation_type === "employee_transfer" && !relocateForm.to_employee_id) {
      setError("Select the employee to transfer this asset to."); return;
    }
    if (["location_change", "return_to_store"].includes(relocateForm.relocation_type) && !relocateForm.to_location.trim()) {
      setError("To Location is required for a Location Change or Return to Store."); return;
    }
    setSavingRelocate(true);
    setError("");
    try {
      await api.post(`/assets/${assetId}/relocate`, relocateForm);
      loadAssetsData(employeeId);
      api.get(`/assets/${assetId}/relocations`).then(r => setAssetRelocations(r.data.relocations || []));
      setShowRelocateForm(false);
      setRelocateForm({ ...BLANK_RELOCATE_FORM });
      flash("Asset relocated.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to relocate this asset.");
    } finally {
      setSavingRelocate(false);
    }
  };

  const deactivateSoftwareAsset = async (assetId, employeeId) => {
    if (!deactivateEvidence.trim()) { setError("Completion evidence is required to deactivate this licence."); return; }
    setSavingDeactivate(true);
    setError("");
    try {
      await api.post(`/assets/${assetId}/software/deactivate`, { completion_evidence: deactivateEvidence });
      loadAssetsData(employeeId);
      setShowDeactivateForm(false);
      setDeactivateEvidence("");
      flash("Licence deactivated.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to deactivate this licence.");
    } finally {
      setSavingDeactivate(false);
    }
  };

  const uploadAssetDocument = async (assetId, file) => {
    const title = (newAssetDocTitle || "").trim();
    if (!title) { setError("Please choose or enter a document title first."); return; }
    setUploadingAssetDoc(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("title", title);
      await api.post(`/assets/${assetId}/documents`, fd);
      api.get(`/assets/${assetId}/documents`).then(r => setAssetDocuments(r.data.documents || []));
      api.get(`/assets/${assetId}/documents/titles`).then(r => setAssetDocumentTitles(r.data.titles || []));
      setNewAssetDocTitle("");
      flash("Document uploaded.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to upload this document.");
    } finally {
      setUploadingAssetDoc(false);
    }
  };

  const viewAssetDocument = async (documentId) => {
    try {
      const res = await api.get(`/assets/documents/${documentId}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
    } catch {
      setError("Could not load this document.");
    }
  };

  const deleteAssetDocument = async (assetId, documentId) => {
    if (!window.confirm("Remove this document?")) return;
    try {
      await api.delete(`/assets/documents/${documentId}`);
      api.get(`/assets/${assetId}/documents`).then(r => setAssetDocuments(r.data.documents || []));
      flash("Document removed.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to remove this document.");
    }
  };

  // ── Employee Offboarding (Milestone 7 backend / part of Milestone 8) ──

  const loadOffboardingClearance = (employeeId) => {
    api.get(`/employees/${employeeId}/offboarding-clearance`)
      .then(r => setOffboardingClearance(r.data))
      .catch(() => setOffboardingClearance(null));
  };

  const startOffboarding = async (employeeId) => {
    if (!offboardingLastDay) { setError("Last Working Day is required to start offboarding."); return; }
    if (!window.confirm("Start offboarding for this employee? This creates return/deactivation tasks for every active asset.")) return;
    setSavingOffboarding(true);
    setError("");
    try {
      const res = await api.post(`/employees/${employeeId}/start-offboarding`, { last_working_date: offboardingLastDay });
      loadOffboardingClearance(employeeId);
      setShowStartOffboarding(false);
      flash(`Offboarding started — ${res.data.tasks_created} task(s) created.`, { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to start offboarding.");
    } finally {
      setSavingOffboarding(false);
    }
  };

  const completeOffboardingTask = async (taskId, employeeId) => {
    try {
      await api.post(`/employees/offboarding-tasks/${taskId}/complete`);
      loadOffboardingClearance(employeeId);
      flash("Task completed.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to complete this task.");
    }
  };

  const exceptionOffboardingTask = async (taskId, employeeId) => {
    const reason = window.prompt("Reason for this exception (required):");
    if (!reason || !reason.trim()) return;
    try {
      await api.post(`/employees/offboarding-tasks/${taskId}/exception`, { reason });
      loadOffboardingClearance(employeeId);
      flash("Exception approved.", { scroll: false });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to approve this exception.");
    }
  };

  const saveBankAccount = async (employeeId) => {
    setSavingBank(true);
    try {
      const body = { ...bankForm };
      Object.keys(body).forEach(k => { if (body[k] === "") delete body[k]; }); // never send blanks — they'd wipe existing masked values
      await api.put(`/employees/${employeeId}/bank-account`, body);
      loadBankAccount(employeeId);
      // Not scrolling to top here — Salary is right below and is very
      // likely the next thing being filled in; jumping to the top would
      // just force scrolling back down again.
      flash("Bank details saved.", { scroll: false });
      setBankJustSaved(true);
      setTimeout(() => setBankJustSaved(false), 2500);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to save bank details.");
    } finally {
      setSavingBank(false);
    }
  };

  const revealBankAccount = async (employeeId) => {
    try {
      const r = await api.get(`/employees/${employeeId}/bank-account?reveal=true`);
      setBankAccount(r.data);
      setBankRevealed(true);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to reveal bank details.");
    }
  };

  const resetNewSalaryForm = () => {
    setEditingSalaryStructureId(null);
    setNewSalaryEffectiveFrom("");
    setNewSalaryComponents({});
    setSelectedSalaryComponentType("");
    setNewSalaryDeductionApplicable(true);
    setNewSalaryDeductionPct("");
    setNewSalaryDeductionBase("basic_salary");
    setNewSalaryAdditionalDeduction("");
    setNewSalaryRemarks("");
  };

  // Loads an existing (not-yet-used-in-payroll) structure into the same
  // add/edit form, so correcting a mistake is "open, fix the number, save"
  // instead of adding a whole new dated version on top of it.
  const startEditSalaryStructure = (s) => {
    setEditingSalaryStructureId(s.id);
    setNewSalaryEffectiveFrom(s.effective_from);
    const comps = {};
    s.components.forEach(c => { comps[c.component_type] = String(c.amount); });
    setNewSalaryComponents(comps);
    setNewSalaryDeductionApplicable(s.statutory_deduction_applicable);
    setNewSalaryDeductionPct(s.statutory_deduction_percentage != null ? String(s.statutory_deduction_percentage) : "");
    setNewSalaryDeductionBase(s.statutory_deduction_calc_base || "basic_salary");
    setNewSalaryAdditionalDeduction(s.additional_deduction != null ? String(s.additional_deduction) : "");
    setNewSalaryRemarks(s.remarks || "");
    setShowAddSalaryForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const addSalaryComponentRow = () => {
    if (!selectedSalaryComponentType) return;
    setNewSalaryComponents(prev => ({ ...prev, [selectedSalaryComponentType]: prev[selectedSalaryComponentType] ?? "" }));
    setSelectedSalaryComponentType("");
  };

  const removeSalaryComponentRow = (componentType) => {
    setNewSalaryComponents(prev => { const next = { ...prev }; delete next[componentType]; return next; });
  };

  const saveNewSalaryComponentType = async () => {
    const label = newSalaryComponentTypeLabel.trim();
    if (!label) { setAddingNewSalaryComponentType(false); return; }
    setSavingNewSalaryComponentType(true);
    try {
      const res = await api.post("/employees/salary-component-options", { label });
      setSalaryComponentOptions(prev => prev.some(c => c.value === res.data.value) ? prev : [...prev, { value: res.data.value, label: res.data.label }]);
      setSelectedSalaryComponentType(res.data.value);
      setAddingNewSalaryComponentType(false);
      setNewSalaryComponentTypeLabel("");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to add salary component type.");
    } finally {
      setSavingNewSalaryComponentType(false);
    }
  };

  const pullSalaryFromContract = async (employeeId) => {
    setPullingSalaryFromContract(true);
    try {
      const r = await api.get(`/employee-documents/resolved-salary-fields?employee_id=${employeeId}`);
      const fields = r.data || {};
      if (Object.keys(fields).length === 0) {
        flash("No approved salary fields found on an Employment Contract for this employee.");
        return;
      }
      setShowAddSalaryForm(true);
      setNewSalaryComponents(prev => {
        const next = { ...prev };
        if (fields.basic_salary != null) next.basic_salary = String(fields.basic_salary);
        if (fields.housing_allowance != null) next.housing_allowance = String(fields.housing_allowance);
        if (fields.transport_allowance != null) next.transport_allowance = String(fields.transport_allowance);
        if (fields.other_allowances != null) next.other_amount = String(fields.other_allowances);
        return next;
      });
      flash("Salary figures pulled from the approved Employment Contract — review and save below.");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to pull salary from contract.");
    } finally {
      setPullingSalaryFromContract(false);
    }
  };

  const saveNewSalaryStructure = async (employeeId) => {
    if (!newSalaryEffectiveFrom) { setError("Effective From date is required for a salary structure."); return; }
    const components = Object.entries(newSalaryComponents)
      .filter(([, amount]) => amount !== "" && !isNaN(Number(amount)))
      .map(([component_type, amount]) => ({ component_type, amount: Number(amount) }));
    if (components.length === 0) { setError("Add at least one salary component with a valid amount."); return; }
    setSavingSalary(true);
    try {
      const payload = {
        components,
        statutory_deduction_applicable: newSalaryDeductionApplicable,
        statutory_deduction_percentage: newSalaryDeductionPct === "" ? null : Number(newSalaryDeductionPct),
        statutory_deduction_calc_base: newSalaryDeductionBase,
        additional_deduction: newSalaryAdditionalDeduction === "" ? null : Number(newSalaryAdditionalDeduction),
        remarks: newSalaryRemarks || null,
      };
      if (editingSalaryStructureId) {
        // Correcting an existing, never-yet-used structure in place — same
        // effective date, no new row. The backend re-checks it's still
        // unused (a payroll could have run between opening this form and
        // clicking Save) and rejects with a clear message if not.
        await api.patch(`/employees/${employeeId}/salary-structures/${editingSalaryStructureId}`, payload);
      } else {
        await api.post(`/employees/${employeeId}/salary-structures`, { effective_from: newSalaryEffectiveFrom, ...payload });
      }
      loadSalaryStructures(employeeId);
      resetNewSalaryForm();
      setShowAddSalaryForm(false);
      // A saved salary structure is exactly the "system" side of the
      // Employment Contract salary comparison (FRD §60) — without this,
      // the mismatch warning on the Documents tab goes stale the moment a
      // new structure is saved, and only catches up the next time
      // something else happens to trigger a refresh.
      refreshCrossCheck(null, employeeId);
      // Not scrolling to top — the new structure now appears right there in
      // the (still-visible) Salary list, that's the confirmation in place.
      flash("Salary structure saved.", { scroll: false });
      setSalaryJustSaved(true);
      setTimeout(() => setSalaryJustSaved(false), 2500);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to save salary structure.");
    } finally {
      setSavingSalary(false);
    }
  };

  const salaryComponentLabel = (type) => salaryComponentOptions.find(c => c.value === type)?.label || type;

  const flash = (text) => {
    // A fixed-position toast (see .adm-toast) is always on screen, so no
    // scroll-to-top is needed anymore — every existing call site still
    // passes an { scroll: false } second arg from before this change;
    // it's simply unused now rather than worth editing at every call site.
    setMsg(text);
    setTimeout(() => setMsg(""), 3000);
  };

  const saveNewEmployee = async (confirmDuplicate = false) => {
    setError("");
    if (!newEmp.classification) { setError("Please select a classification first."); setFormTab("employment"); return; }
    if (!newEmp.full_name.trim()) { setError("Full name is required."); return; }
    setSavingEmployee(true);
    try {
      const body = buildCreateBody(newEmp, confirmDuplicate);
      body.document_ids = uploadedDocs.map(d => d.document_id);
      const res = await api.post("/employees", body);
      if (res.data.duplicate_warning) {
        setDupWarning({ duplicates: res.data.duplicates, mode: "add" });
        return;
      }
      setDupWarning(null);
      setUploadedDocs([]);
      flash(`Employee ${res.data.employee_code} created (${res.data.employment_status}) — now add banking and salary details.`, { scroll: false });
      load();
      // Stay on this employee instead of bouncing back to the list — Banking
      // and Salary need a real employee_id to exist, so continue straight
      // into Edit mode instead of making HR find this employee again and
      // click Edit themselves. Land straight on the Banking tab — no more
      // scrolling required now that Banking/Salary are tabs, not sections
      // further down a long page.
      startEdit({ ...newEmp, id: res.data.id, employee_code: res.data.employee_code, employment_status: res.data.employment_status });
      setFormTab("banking");
      setNewEmp({ ...BLANK_EMPLOYEE });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to create employee.");
    } finally {
      setSavingEmployee(false);
    }
  };

  // Available from every tab while adding a new employee — not just the
  // last one. Without this, everything typed across Documents/Personal/
  // Contact/Employment lives only in local state until "Create Employee" on
  // the final tab; leaving before then (closing the tab, clicking away,
  // a browser crash) loses all of it with nothing saved anywhere. This
  // creates the employee as soon as the two fields the backend actually
  // requires (Full Name, Classification) are filled in, then hands off into
  // real Edit mode on the same tab the user was already on — from there,
  // the normal per-tab "Save Changes" button (now fixed to stay in place,
  // see saveEditedEmployee) takes over.
  const saveProgress = async () => {
    setError("");
    if (!newEmp.full_name.trim()) { setError("Full name is required to save."); return; }
    if (!newEmp.classification) { setError("Please select a classification first — required before this can be saved."); setFormTab("employment"); return; }
    setSavingEmployee(true);
    try {
      const body = buildCreateBody(newEmp, false);
      body.document_ids = uploadedDocs.map(d => d.document_id);
      const res = await api.post("/employees", body);
      if (res.data.duplicate_warning) {
        setDupWarning({ duplicates: res.data.duplicates, mode: "add" });
        return;
      }
      setDupWarning(null);
      setUploadedDocs([]);
      flash(`Progress saved — ${res.data.employee_code} created. Keep going whenever you're ready, or come back later.`, { scroll: false });
      load();
      const savedTab = formTab;
      startEdit({ ...newEmp, id: res.data.id, employee_code: res.data.employee_code, employment_status: res.data.employment_status });
      setFormTab(savedTab);
      setNewEmp({ ...BLANK_EMPLOYEE });
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to save progress.");
    } finally {
      setSavingEmployee(false);
    }
  };

  const startEdit = (emp, mode = "edit") => {
    setEditingEmp({ ...emp });
    setView(mode);
    setDupWarning(null);
    setCrossCheckWarning(null);
    setSelectedIdType("");
    setCollapsedDocIds([]);
    setUploaderOpen(false); // editing likely already has documents — start compact
    setFormTab("documents");
    loadFormDocs(null, emp.id);
    refreshCrossCheck(null, emp.id);
    loadBankAccount(emp.id);
    loadSalaryStructures(emp.id);
    loadPayrollHistory(emp.id);
    setExpandedHistoryEntryId(null);
    resetNewSalaryForm();
    setShowAddSalaryForm(false);
    if (isEligibleForLeave(emp.nationality)) loadLeaveData(emp.id);
    else { setLeaveSummary(null); setLeaveEntries([]); }
    resetNewLeaveForm();
    setShowAddLeaveForm(false);
    // No eligibility gate for Loans — every employee qualifies.
    loadLoansData(emp.id);
    resetNewLoanForm();
    setShowAddLoanForm(false);
    setExpandedLoanId(null);
    setLoanDeductions([]);
    setLoanDocuments([]);
    setPlanDraft(null);
    // No eligibility gate for Assets — every employee qualifies.
    loadAssetsData(emp.id);
    resetNewAssetForm();
    setShowAddAssetForm(false);
    setExpandedAssetId(null);
    setAssetRelocations([]);
    setAssetDocuments([]);
    setShowRelocateForm(false);
    setShowDeactivateForm(false);
    loadOffboardingClearance(emp.id);
    setShowStartOffboarding(false);
    setOffboardingLastDay("");
  };

  const startView = (emp) => startEdit(emp, "view"); // same data load as Edit, read-only render (see `readOnly` below)

  // ── Document upload + OCR review (Milestone 3) ──────────────
  const startAddFlow = () => {
    setDraftSessionId(crypto.randomUUID());
    setUploadedDocs([]);
    setFormDocs([]);
    setCrossCheckWarning(null);
    setDupWarning(null);
    setError("");
    setSelectedIdType("");
    setCollapsedDocIds([]);
    setUploaderOpen(false); // start collapsed to a "+ Upload Document" button — click to expand
    setFormTab("documents");
    setNewEmp({ ...BLANK_EMPLOYEE });
    setView("add");
  };

  // Loads the document list (with extraction fields) for the currently open
  // Add/Edit form — pass whichever id applies, the other should be null.
  const loadFormDocs = async (draftId, employeeId) => {
    if (!draftId && !employeeId) { setFormDocs([]); return; }
    try {
      const qs = employeeId ? `employee_id=${employeeId}` : `draft_session_id=${draftId}`;
      const r = await api.get(`/employee-documents?${qs}`);
      setFormDocs(r.data || []);
    } catch {
      setFormDocs([]);
    }
  };

  const viewDocument = async (documentId) => {
    try {
      const res = await api.get(`/employee-documents/${documentId}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
    } catch {
      setError("Could not load document image.");
    }
  };

  // targetEmployeeId set = uploading into an existing (Edit) employee's
  // record directly; unset = part of the Add-flow draft session.
  const uploadDocument = async (file, document_type, targetEmployeeId = null) => {
    setExtractingSlot(document_type);
    setError("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("document_type", document_type);
      if (targetEmployeeId) fd.append("employee_id", targetEmployeeId);
      else fd.append("draft_session_id", draftSessionId);
      const res = await api.post("/employee-documents/upload", fd);
      if (!res.data.ok) {
        setError(`Could not read this document (${document_type.replace(/_/g, " ")}) — try a clearer photo, or skip it and enter details manually.`);
        return;
      }
      if (!targetEmployeeId) {
        setUploadedDocs(prev => [...prev.filter(d => d.document_type !== document_type), res.data]);
      }
      await loadFormDocs(targetEmployeeId ? null : draftSessionId, targetEmployeeId || null);
      await refreshCrossCheck(targetEmployeeId ? null : draftSessionId, targetEmployeeId || null);
      if (res.data.duplicates?.length) setDupWarning({ duplicates: res.data.duplicates, mode: targetEmployeeId ? "edit" : "add" });
    } catch (e) {
      setError(e.response?.data?.detail || "Upload failed.");
    } finally {
      setExtractingSlot(null);
    }
  };

  // Corrects a document's type after a wrong pick — re-reads the same
  // stored file with the right prompt server-side, so the extracted fields
  // actually match the corrected type instead of just relabeling stale ones.
  const changeDocumentType = async (documentId, newType, employeeId) => {
    if (!newType) return;
    setError("");
    setSavingType(true);
    try {
      await api.patch(`/employee-documents/${documentId}/type`, { document_type: newType });
      await loadFormDocs(employeeId ? null : draftSessionId, employeeId || null);
      await refreshCrossCheck(employeeId ? null : draftSessionId, employeeId || null);
      setEditingTypeDocId(null);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to change document type.");
    } finally {
      setSavingType(false);
    }
  };

  const startFieldEdit = (documentId, fieldName, currentValue) => {
    setEditingFieldKey(`${documentId}:${fieldName}`);
    setEditingFieldValue(currentValue || "");
  };
  const cancelFieldEdit = () => { setEditingFieldKey(null); setEditingFieldValue(""); };

  const reviewFormField = async (documentId, fieldName, action, value, employeeId) => {
    try {
      await approveField(documentId, fieldName, action, value);
      await loadFormDocs(employeeId ? null : draftSessionId, employeeId || null);
      await pullResolvedFields(employeeId);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to save review.");
    }
  };

  // Documents section (Edit/Add form): accept every not-yet-reviewed field on one document.
  const acceptAllDocFields = async (doc, employeeId) => {
    const pending = (doc.fields || []).filter(f => !f.approval_action);
    setAcceptingAllDocId(doc.id);
    try {
      await Promise.all(pending.map(f => approveField(doc.id, f.field_name, "accept", f.ai_extracted_value)));
      await loadFormDocs(employeeId ? null : draftSessionId, employeeId || null);
      await pullResolvedFields(employeeId);
      flash(`${pending.length} field${pending.length === 1 ? "" : "s"} accepted.`);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to accept all fields.");
    } finally {
      setAcceptingAllDocId(null);
    }
  };

  // Used to be a separate "Pull Approved Values into Form" button HR had to
  // remember to click — now runs automatically right after Accept/Accept
  // All/a manual field save, so an approved value lands in the form
  // immediately instead of waiting on an extra manual step. Silent by
  // design: the visible effect (the form field populating) is the feedback,
  // and a failure here shouldn't compete with the accept action's own
  // success/error state.
  const pullResolvedFields = async (employeeId) => {
    try {
      const qs = employeeId ? `employee_id=${employeeId}` : `draft_session_id=${draftSessionId}`;
      const r = await api.get(`/employee-documents/resolved-fields?${qs}`);
      if (employeeId) setEditingEmp(prev => ({ ...prev, ...r.data }));
      else setNewEmp(prev => ({ ...prev, ...r.data }));
    } catch {
      // Non-fatal — the field was still accepted either way; the form just
      // didn't pick up the resolved value this time.
    }
  };

  const removeDocument = async (documentId, employeeId) => {
    try {
      await api.delete(`/employee-documents/${documentId}`);
      await loadFormDocs(employeeId ? null : draftSessionId, employeeId || null);
      await refreshCrossCheck(employeeId ? null : draftSessionId, employeeId || null);
      if (!employeeId) setUploadedDocs(prev => prev.filter(d => d.document_id !== documentId));
      flash("Document removed.");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to remove document.");
    }
  };

  // Re-runs the Civil ID vs Passport mismatch check whenever a document is
  // added/changed, so a new mismatch is never missed.
  const refreshCrossCheck = async (draftId, employeeId) => {
    if (!draftId && !employeeId) { setCrossCheckWarning(null); return; }
    try {
      const qs = employeeId ? `employee_id=${employeeId}` : `draft_session_id=${draftId}`;
      const r = await api.get(`/employee-documents/cross-check?${qs}`);
      setCrossCheckWarning(r.data.mismatches?.length ? r.data.mismatches : null);
    } catch { /* non-fatal, screen still usable */ }
  };

  const approveField = async (document_id, field_name, action, value) => {
    await api.patch(`/employee-documents/${document_id}/fields`, [{ field_name, action, value }]);
  };

  const saveEditedEmployee = async () => {
    setError("");
    setSavingEmployee(true);
    try {
      const patch = { ...editingEmp };
      delete patch.id; delete patch.org_id; delete patch.employee_code;
      delete patch.created_by; delete patch.created_at; delete patch.updated_at; delete patch.is_deleted;
      Object.keys(patch).forEach(k => { if (patch[k] === "") patch[k] = null; });
      const res = await api.patch(`/employees/${editingEmp.id}`, patch);
      // Deliberately stays on the form instead of returning to the list —
      // this button is now reachable from every tab (Documents/Personal/
      // Contact/Employment), and bouncing back out after every single save
      // would force re-opening Edit and re-finding the right tab just to
      // keep going. "Cancel" below is still there for when they're done.
      if (res.data.note) {
        // Backend silently forced employment_status back to "draft" (no
        // identity document on file yet) — reflect that locally so the
        // form doesn't keep showing a status that no longer matches the DB.
        setEditingEmp(prev => ({ ...prev, employment_status: "draft" }));
      }
      flash(res.data.note || "Saved.", { scroll: false });
      load();
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to update employee.");
    } finally {
      setSavingEmployee(false);
    }
  };

  const removeEmployee = async (emp) => {
    if (!window.confirm(`Remove ${emp.full_name} (${emp.employee_code})?`)) return;
    await api.delete(`/employees/${emp.id}`);
    setEmployees(prev => prev.filter(e => e.id !== emp.id));
  };

  const handleAiSearch = async () => {
    if (!aiQuery.trim()) return;
    setAiSearching(true);
    setError("");
    try {
      const res = await api.post("/employees/search/ai", { query: aiQuery });
      setAiResults(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || "AI search failed.");
    } finally {
      setAiSearching(false);
    }
  };

  const clearAiSearch = () => {
    setAiQuery("");
    setAiResults(null);
  };

  const field = (label, node) => (
    <div className="adm-field"><label className="adm-label">{label}</label>{node}</div>
  );

  const documentTypeLabel = (type) => {
    for (const o of FIXED_ID_TYPE_OPTIONS) {
      const part = o.parts.find(p => p.type === type);
      if (part) return part.label;
    }
    return attachTypes.find(t => t.value === type)?.label || type;
  };

  const countryCodeSelect = (value, onChange, disabled = false) => (
    <select className="adm-select" disabled={disabled} value={value || ""} onChange={onChange}>
      <option value="">— Select —</option>
      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code}>{c.code} — {c.name}</option>)}
    </select>
  );

  const saveNewDocumentType = async () => {
    const label = newTypeLabel.trim();
    if (!label) { setAddingNewType(false); return; }
    setSavingNewType(true);
    try {
      const res = await api.post("/employee-documents/document-types", { label });
      setAttachTypes(prev => prev.some(t => t.value === res.data.value) ? prev : [...prev, { value: res.data.value, label: res.data.label, is_builtin: false }]);
      // Route the newly-created type into whichever picker actually opened
      // this "+ Add new document type…" — the ID-type picker, or a
      // per-document type correction.
      if (newTypeTarget === "editType") setEditingTypeValue(res.data.value);
      else setSelectedIdType(res.data.value);
      setAddingNewType(false);
      setNewTypeLabel("");
      setNewTypeTarget(null);
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to add document type.");
    } finally {
      setSavingNewType(false);
    }
  };

  // Removes a custom (org-added) document type from being offered for new
  // uploads. Documents already uploaded under it are untouched — same
  // "removing the option doesn't touch existing data" convention as the
  // (currently orphaned) salary-component-options delete endpoint.
  const removeCustomDocumentType = async (value, label) => {
    if (!window.confirm(`Remove "${label}" from the document type list? Documents already uploaded as this type keep their data — this only stops it being offered for new uploads.`)) return;
    try {
      await api.delete(`/employee-documents/document-types/${value}`);
      setAttachTypes(prev => prev.filter(t => t.value !== value));
      if (selectedIdType === value) setSelectedIdType("");
      if (editingTypeValue === value) setEditingTypeValue("");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to remove document type.");
    }
  };

  // Reusable ID-management sub-module: pick an ID type, then upload just the
  // image slot(s) that type needs. Used both for the initial Add Employee
  // upload step and inside the Documents section on Add/Edit forms. The
  // list combines the 4 fixed identity types with org-customizable "other"
  // types (built-ins + anything added via "+ Add new document type…").
  // Flat {value,label} list of every real document_type — unlike
  // idTypeOptions inside renderIdUploader (grouped, built for the manual
  // front/back-slot picker), this needs one option per actual document_type
  // since both the AI's guess and a post-upload correction target one
  // specific type (e.g. "civil_id_front"), never a group. Shared by the
  // auto-detect confirm step and the per-document type-correction dropdown.
  const flatTypeOptions = [
    { value: "civil_id_front", label: "Civil ID — Front" },
    { value: "civil_id_back", label: "Civil ID — Back" },
    { value: "passport", label: "Passport" },
    { value: "foreign_id", label: "Foreign ID" },
    { value: "residence_permit", label: "Residence Permit" },
    ...attachTypes,
  ];

  const renderIdUploader = (employeeId) => {
    const docs = employeeId ? formDocs : uploadedDocs;
    const idTypeOptions = [
      ...FIXED_ID_TYPE_OPTIONS,
      ...attachTypes.map(t => ({ key: t.value, label: t.label, ocr: false, parts: [{ type: t.value, label: t.label }] })),
    ];
    const selected = idTypeOptions.find(o => o.key === selectedIdType);

    if (!uploaderOpen) {
      return (
        <button type="button" className="adm-action-btn" onClick={() => setUploaderOpen(true)}>
          + {docs.length === 0 ? "Upload Document" : "Upload Another Document"}
        </button>
      );
    }

    return (
      <div style={{ marginBottom: 10 }}>
        {docs.length > 0 && (
          <div style={{ textAlign: "right", marginBottom: 4 }}>
            <button type="button" onClick={() => { setUploaderOpen(false); setSelectedIdType(""); }}
                    style={{ background: "none", border: "none", color: "#6080aa", fontSize: 11, cursor: "pointer", padding: 0 }}>
              ✕ Close
            </button>
          </div>
        )}

        <div className="adm-field" style={{ maxWidth: 300, marginBottom: 12 }}>
          <label className="adm-label">ID Type</label>
          {addingNewType && newTypeTarget === "manual" ? (
            <div style={{ display: "flex", gap: 6 }}>
              <input className="adm-input" autoFocus disabled={savingNewType} value={newTypeLabel}
                     onChange={e => setNewTypeLabel(e.target.value)}
                     onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); saveNewDocumentType(); } if (e.key === "Escape") setAddingNewType(false); }}
                     placeholder="e.g. Trade License" />
              <button type="button" className="adm-action-btn" disabled={savingNewType} onClick={saveNewDocumentType}>Save</button>
              <button type="button" className="adm-action-btn" disabled={savingNewType} onClick={() => setAddingNewType(false)}>Cancel</button>
            </div>
          ) : (
            <select className="adm-select" value={selectedIdType}
                    onChange={e => { if (e.target.value === ADD_NEW_DOC_TYPE) { setNewTypeLabel(""); setNewTypeTarget("manual"); setAddingNewType(true); } else { setSelectedIdType(e.target.value); } }}>
              <option value="">— Select ID Type —</option>
              {idTypeOptions.map(o => <option key={o.key} value={o.key}>{o.label}</option>)}
              <option value={ADD_NEW_DOC_TYPE}>+ Add new document type…</option>
            </select>
          )}
          {attachTypes.some(t => !t.is_builtin) && (
            <div style={{ marginTop: 8 }}>
              <div style={{ fontSize: 11, color: "#8b8f7f", marginBottom: 4 }}>Custom types added by your org:</div>
              {attachTypes.filter(t => !t.is_builtin).map(t => (
                <div key={t.value} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, padding: "3px 0" }}>
                  <span>{t.label}</span>
                  <button type="button" onClick={() => removeCustomDocumentType(t.value, t.label)}
                          style={{ background: "none", border: "none", color: "#dc2626", fontSize: 11, cursor: "pointer", padding: 0 }}>
                    ✕ Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
        {selected && (
          <div className="adm-upload-grid">
            {selected.parts.map(part => {
              const uploaded = docs.find(d => d.document_type === part.type);
              return (
                <div key={part.type} className={`adm-upload-slot${uploaded ? " filled" : ""}`}>
                  <div className="adm-label" style={{ marginBottom: 8 }}>{part.label}{uploaded ? " ✓" : ""}</div>
                  <input type="file" accept="image/jpeg,image/png,application/pdf" disabled={extractingSlot === part.type}
                         onChange={e => { const f = e.target.files?.[0]; if (f) uploadDocument(f, part.type, employeeId); e.target.value = ""; }} />
                  {extractingSlot === part.type && <div style={{ fontSize: 11, color: "#0284c7", marginTop: 6 }}>{selected.ocr ? "Reading document…" : "Uploading…"}</div>}
                  {uploaded && (
                    <div style={{ fontSize: 11, color: uploaded.ocr_status === "completed" ? "#059669" : "#b45309", marginTop: 6 }}>
                      {!selected.ocr ? "Attached" : uploaded.ocr_status === "completed" ? "Read successfully" : "Some fields need review"}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  // employeeId set = Edit form (documents fetched/uploaded against the real
  // employee record); null = Add form (documents scoped to the draft session).
  const renderDocumentsSection = (employeeId) => (
    <>
      <div className="adm-fieldset-title">Documents</div>
      {crossCheckWarning && (
        <div className="adm-warning">
          <strong>Possible mismatch between documents:</strong>
          <ul style={{ margin: "6px 0 0 18px" }}>
            {crossCheckWarning.map((m, i) => (
              <li key={`${m.field}-${i}`}>{m.message}</li>
            ))}
          </ul>
        </div>
      )}
      {formDocs.length === 0 && (
        <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No documents uploaded yet.</div>
      )}
      {formDocs.map(doc => {
        const isCollapsed = collapsedDocIds.includes(doc.id);
        return (
        <div key={doc.id} style={{ border: "1px solid #dbe6f2", borderRadius: 7, padding: "10px 12px", marginBottom: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ cursor: "pointer", flex: 1 }} onClick={() => toggleDocCollapsed(doc.id)}>
              <span style={{ display: "inline-block", width: 14, color: "#6080aa" }}>{isCollapsed ? "▶" : "▼"}</span>
              <strong style={{ fontSize: 13 }}>{documentTypeLabel(doc.document_type)}</strong>
              {/* "completed" means two different things depending on the document
                  type: real AI extraction that succeeded (fields present), or a
                  type with no reading logic at all (nothing was ever attempted,
                  fields is empty) -- same word, very different situations. Say
                  "attached" for the second case instead of reusing "completed"
                  as if data had actually been read. */}
              <span className={`adm-confidence ${doc.ocr_status === "completed" ? "high" : "low"}`} style={{ marginLeft: 8 }}>
                {doc.fields?.length > 0 ? doc.ocr_status.replace(/_/g, " ") : "attached"}
              </span>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              {!readOnly && doc.fields?.some(f => !f.approval_action) && (
                <button type="button" className="adm-action-btn" disabled={acceptingAllDocId === doc.id}
                        onClick={() => acceptAllDocFields(doc, employeeId)}>
                  {acceptingAllDocId === doc.id ? "Accepting…" : "Accept All"}
                </button>
              )}
              {!readOnly && (
                <button type="button" className="adm-action-btn"
                        onClick={() => { setEditingTypeDocId(editingTypeDocId === doc.id ? null : doc.id); setEditingTypeValue(doc.document_type); }}>
                  Change Type
                </button>
              )}
              <button type="button" className="adm-action-btn" onClick={() => viewDocument(doc.id)}>View</button>
              {!readOnly && (
                <button type="button" className="adm-action-btn danger" onClick={() => { if (window.confirm(`Remove this ${documentTypeLabel(doc.document_type)} document?`)) removeDocument(doc.id, employeeId); }}>Remove</button>
              )}
            </div>
          </div>
          {!readOnly && editingTypeDocId === doc.id && (
            <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap", marginTop: 8, padding: "8px 0", borderTop: "1px solid #eef3f9" }}>
              {addingNewType && newTypeTarget === "editType" ? (
                <>
                  <input className="adm-input" style={{ fontSize: 12, padding: "4px 8px" }} autoFocus disabled={savingNewType} value={newTypeLabel}
                         onChange={e => setNewTypeLabel(e.target.value)}
                         onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); saveNewDocumentType(); } if (e.key === "Escape") setAddingNewType(false); }}
                         placeholder="e.g. Trade License" />
                  <button type="button" className="adm-action-btn" disabled={savingNewType} onClick={saveNewDocumentType}>Save</button>
                  <button type="button" className="adm-action-btn" disabled={savingNewType} onClick={() => setAddingNewType(false)}>Cancel</button>
                </>
              ) : (
                <>
                  <span style={{ fontSize: 12, color: "#5c7291" }}>Actual document type:</span>
                  <select className="adm-select" value={editingTypeValue}
                          onChange={e => { if (e.target.value === ADD_NEW_DOC_TYPE) { setNewTypeLabel(""); setNewTypeTarget("editType"); setAddingNewType(true); } else { setEditingTypeValue(e.target.value); } }}>
                    {flatTypeOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    <option value={ADD_NEW_DOC_TYPE}>+ Add new document type…</option>
                  </select>
                  <button type="button" className="adm-action-btn" disabled={savingType || editingTypeValue === doc.document_type}
                          onClick={() => changeDocumentType(doc.id, editingTypeValue, employeeId)}>
                    {savingType ? "Saving…" : "Save"}
                  </button>
                  <button type="button" className="adm-action-btn" disabled={savingType} onClick={() => setEditingTypeDocId(null)}>Cancel</button>
                </>
              )}
            </div>
          )}
          {!isCollapsed && doc.fields?.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {doc.fields.map(f => {
                const key = `${doc.id}:${f.field_name}`;
                const isEditing = editingFieldKey === key;
                const hasAiValue = !!f.ai_extracted_value;
                const editAction = hasAiValue ? "edit" : "manual";
                return (
                  <div key={f.field_name} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, padding: "5px 0", borderTop: "1px solid #eef3f9" }}>
                    <span style={{ width: 130, color: "#5c7291" }}>{f.field_name.replace(/_/g, " ")}</span>
                    {isEditing ? (
                      <>
                        <input className="adm-input" style={{ flex: 1, fontSize: 12, padding: "4px 8px" }} value={editingFieldValue}
                               onChange={e => setEditingFieldValue(e.target.value)} autoFocus
                               onKeyDown={e => { if (e.key === "Enter") { reviewFormField(doc.id, f.field_name, editAction, editingFieldValue, employeeId); cancelFieldEdit(); } if (e.key === "Escape") cancelFieldEdit(); }} />
                        <button type="button" className="adm-action-btn" onClick={() => { reviewFormField(doc.id, f.field_name, editAction, editingFieldValue, employeeId); cancelFieldEdit(); }}>Save</button>
                        <button type="button" className="adm-action-btn" onClick={cancelFieldEdit}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1 }}>{f.approved_value ?? f.ai_extracted_value ?? "—"}</span>
                        <span className={`adm-confidence ${f.ai_confidence >= CONFIDENCE_THRESHOLD ? "high" : "low"}`}>{f.ai_confidence}%</span>
                        {f.approval_action ? (
                          <span style={{ color: "#059669", fontSize: 11 }}>
                            {f.approval_action}
                            {(f.approved_by_name || f.approved_by_email) && ` by ${f.approved_by_name || f.approved_by_email}`}
                            {f.approved_at && ` on ${new Date(f.approved_at).toLocaleString()}`}
                          </span>
                        ) : !readOnly && hasAiValue ? (
                          <>
                            <button type="button" className="adm-action-btn" onClick={() => reviewFormField(doc.id, f.field_name, "accept", f.ai_extracted_value, employeeId)}>Accept</button>
                            <button type="button" className="adm-action-btn" onClick={() => startFieldEdit(doc.id, f.field_name, f.ai_extracted_value)}>Edit</button>
                            <button type="button" className="adm-action-btn" onClick={() => reviewFormField(doc.id, f.field_name, "reject", null, employeeId)}>Reject</button>
                          </>
                        ) : !readOnly ? (
                          <button type="button" className="adm-action-btn" onClick={() => startFieldEdit(doc.id, f.field_name, "")}>Enter Manually</button>
                        ) : null}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        );
      })}

      {!readOnly && (
        <div style={{ marginTop: 10 }}>
          {renderIdUploader(employeeId)}
        </div>
      )}
    </>
  );

  // employeeId null = not saved yet, nothing to load/save here until the
  // employee actually exists (banking/salary are keyed on employee_id only,
  // unlike documents there's no pre-creation draft-session equivalent).
  const renderBankingSection = (employeeId, classification) => (
    <>
      <div className="adm-fieldset-title">Banking</div>
      {!employeeId ? (
        <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first, then add bank details.</div>
      ) : (
        <>
          {bankAccount && (bankAccount.account_number || bankAccount.iban) && (
            <div style={{ fontSize: 12, color: "#5c7291", marginBottom: 10 }}>
              Account: <strong>{bankAccount.account_number || "—"}</strong>{"   "}
              IBAN: <strong>{bankAccount.iban || "—"}</strong>
              {!bankRevealed && (
                <button type="button" className="adm-action-btn" style={{ marginLeft: 8 }} onClick={() => revealBankAccount(employeeId)}>Reveal Full Numbers</button>
              )}
            </div>
          )}
          {classification === "payroll" && !bankAccount && (
            <div className="adm-warning" style={{ marginBottom: 10 }}>This is a Payroll employee with no bank details on file yet.</div>
          )}
          <div className="adm-form-grid">
            {field("Bank Name", <input className="adm-input" disabled={readOnly} value={bankForm.bank_name ?? bankAccount?.bank_name ?? ""} onChange={e => setBankForm(p => ({ ...p, bank_name: e.target.value }))} />)}
            {field("Bank Code", <input className="adm-input" disabled={readOnly} value={bankForm.bank_code ?? bankAccount?.bank_code ?? ""} onChange={e => setBankForm(p => ({ ...p, bank_code: e.target.value }))} />)}
            {field("Account Number", <input className="adm-input" disabled={readOnly} placeholder={bankAccount?.account_number ? "Leave blank to keep unchanged" : ""} value={bankForm.account_number || ""} onChange={e => setBankForm(p => ({ ...p, account_number: e.target.value }))} />)}
            {field("IBAN", <input className="adm-input" disabled={readOnly} placeholder={bankAccount?.iban ? "Leave blank to keep unchanged" : ""} value={bankForm.iban || ""} onChange={e => setBankForm(p => ({ ...p, iban: e.target.value }))} />)}
            {field("Name as per Bank", <input className="adm-input" disabled={readOnly} value={bankForm.name_as_per_bank ?? bankAccount?.name_as_per_bank ?? ""} onChange={e => setBankForm(p => ({ ...p, name_as_per_bank: e.target.value }))} />)}
            {field("Bank Country", <input className="adm-input" disabled={readOnly} value={bankForm.bank_country ?? bankAccount?.bank_country ?? ""} onChange={e => setBankForm(p => ({ ...p, bank_country: e.target.value }))} />)}
            {field("Branch", <input className="adm-input" disabled={readOnly} value={bankForm.branch ?? bankAccount?.branch ?? ""} onChange={e => setBankForm(p => ({ ...p, branch: e.target.value }))} />)}
            {field("Bank BIC / SWIFT Code (for WPS)", <input className="adm-input" disabled={readOnly} placeholder="e.g. BMUSOMRX" value={bankForm.wps_bank_identifier ?? bankAccount?.wps_bank_identifier ?? ""} onChange={e => setBankForm(p => ({ ...p, wps_bank_identifier: e.target.value }))} />)}
          </div>
          {!readOnly && (
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10 }}>
              <button type="button" className="adm-submit" disabled={savingBank} onClick={() => saveBankAccount(employeeId)}>
                {savingBank ? "Saving…" : "Save Bank Details"}
              </button>
              {bankJustSaved && <span style={{ color: "#059669", fontSize: 13, fontWeight: 600 }}>✓ Saved</span>}
            </div>
          )}
        </>
      )}
    </>
  );

  const renderSalarySection = (employeeId) => (
    <>
      <div className="adm-fieldset-title">
        Salary{salaryJustSaved && <span style={{ color: "#059669", fontSize: 12, fontWeight: 600, marginLeft: 10 }}>✓ Saved</span>}
      </div>
      {!employeeId ? (
        <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first, then add a salary structure.</div>
      ) : (
        <>
          {salaryStructures.length === 0 && !showAddSalaryForm && (
            <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No salary structure yet.</div>
          )}
          {salaryStructures.map(s => (
            <div key={s.id} style={{ border: "1px solid #dbe6f2", borderRadius: 7, padding: "10px 12px", marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <strong style={{ fontSize: 13 }}>Effective {s.effective_from}</strong>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  {s.is_current && <span className="adm-confidence high">Current</span>}
                  {s.is_locked ? (
                    <span style={{ fontSize: 11, color: "#8092ab" }} title="Already used in a calculated payroll — can't be edited, only superseded by a new dated entry.">🔒 Used in payroll</span>
                  ) : !readOnly ? (
                    <button type="button" className="adm-action-btn" style={{ padding: "3px 10px", fontSize: 12 }} onClick={() => startEditSalaryStructure(s)}>Edit</button>
                  ) : null}
                </div>
              </div>
              <div style={{ marginTop: 6 }}>
                {s.components.map(c => (
                  <div key={c.component_type} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, padding: "3px 0" }}>
                    <span style={{ color: "#5c7291" }}>{salaryComponentLabel(c.component_type)}</span>
                    <span>{c.amount.toFixed(3)}</span>
                  </div>
                ))}
                {s.statutory_deduction_applicable && s.statutory_deduction_percentage != null && (
                  <div style={{ fontSize: 11, color: "#6080aa", marginTop: 4 }}>
                    Statutory deduction: {s.statutory_deduction_percentage}% of {s.statutory_deduction_calc_base.replace(/_/g, " ")}
                  </div>
                )}
                {s.remarks && <div style={{ fontSize: 11, color: "#6080aa", marginTop: 4 }}>Remarks: {s.remarks}</div>}
              </div>
            </div>
          ))}

          {readOnly ? null : !showAddSalaryForm ? (
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button type="button" className="adm-action-btn" onClick={() => setShowAddSalaryForm(true)}>+ Add New Salary Version</button>
              <button type="button" className="adm-action-btn" disabled={pullingSalaryFromContract} onClick={() => pullSalaryFromContract(employeeId)}>
                {pullingSalaryFromContract ? "Pulling…" : "Pull Salary from Approved Contract"}
              </button>
            </div>
          ) : (
            <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12 }}>
              <div className="adm-fieldset-title" style={{ fontSize: 12, marginBottom: 8 }}>
                {editingSalaryStructureId ? "Edit Salary Structure" : "Add New Salary Version"}
              </div>
              <div className="adm-form-grid">
                {editingSalaryStructureId ? (
                  field("Effective From", <div className="adm-input" style={{ background: "#f3f6fb", color: "#5c7291" }}>{newSalaryEffectiveFrom} (can't be changed while editing)</div>)
                ) : (
                  field("Effective From *", <input type="date" className="adm-input" value={newSalaryEffectiveFrom} onChange={e => setNewSalaryEffectiveFrom(e.target.value)} />)
                )}
              </div>

              <div className="adm-label" style={{ margin: "10px 0 6px" }}>Components</div>
              {Object.entries(newSalaryComponents).map(([type, amount]) => (
                <div key={type} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <span style={{ width: 160, fontSize: 12, color: "#5c7291" }}>{salaryComponentLabel(type)}</span>
                  <input className="adm-input" style={{ maxWidth: 160 }} type="number" step="0.001" value={amount}
                         onChange={e => setNewSalaryComponents(prev => ({ ...prev, [type]: e.target.value }))} />
                  <button type="button" className="adm-action-btn danger" onClick={() => removeSalaryComponentRow(type)}>Remove</button>
                </div>
              ))}
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
                {addingNewSalaryComponentType ? (
                  <>
                    <input className="adm-input" style={{ maxWidth: 200 }} autoFocus disabled={savingNewSalaryComponentType} value={newSalaryComponentTypeLabel}
                           onChange={e => setNewSalaryComponentTypeLabel(e.target.value)}
                           onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); saveNewSalaryComponentType(); } if (e.key === "Escape") setAddingNewSalaryComponentType(false); }}
                           placeholder="e.g. Housing Allowance" />
                    <button type="button" className="adm-action-btn" disabled={savingNewSalaryComponentType} onClick={saveNewSalaryComponentType}>Save</button>
                    <button type="button" className="adm-action-btn" disabled={savingNewSalaryComponentType} onClick={() => setAddingNewSalaryComponentType(false)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <select className="adm-select" style={{ maxWidth: 200 }} value={selectedSalaryComponentType}
                            onChange={e => { if (e.target.value === "__add_new_salary_component__") { setNewSalaryComponentTypeLabel(""); setAddingNewSalaryComponentType(true); } else { setSelectedSalaryComponentType(e.target.value); } }}>
                      <option value="">— Select Component —</option>
                      {salaryComponentOptions.filter(c => !(c.value in newSalaryComponents)).map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                      <option value="__add_new_salary_component__">+ Add new component…</option>
                    </select>
                    <button type="button" className="adm-action-btn" disabled={!selectedSalaryComponentType} onClick={addSalaryComponentRow}>Add</button>
                  </>
                )}
              </div>

              <div className="adm-fieldset-title" style={{ fontSize: 11 }}>Statutory Deduction</div>
              <div className="adm-form-grid">
                {field("Applicable", (
                  <select className="adm-select" value={newSalaryDeductionApplicable ? "yes" : "no"} onChange={e => setNewSalaryDeductionApplicable(e.target.value === "yes")}>
                    <option value="yes">Yes</option><option value="no">No</option>
                  </select>
                ))}
                {field("Percentage", <input className="adm-input" type="number" step="0.001" value={newSalaryDeductionPct} onChange={e => setNewSalaryDeductionPct(e.target.value)} />)}
                {field("Calculation Base", (
                  <select className="adm-select" value={newSalaryDeductionBase} onChange={e => setNewSalaryDeductionBase(e.target.value)}>
                    <option value="basic_salary">Basic Salary</option>
                    <option value="gross_salary">Gross Salary</option>
                  </select>
                ))}
                {field("Additional Deduction", <input className="adm-input" type="number" step="0.001" value={newSalaryAdditionalDeduction} onChange={e => setNewSalaryAdditionalDeduction(e.target.value)} />)}
              </div>
              {field("Remarks", <textarea className="adm-input" rows={2} value={newSalaryRemarks} onChange={e => setNewSalaryRemarks(e.target.value)} />)}

              <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
                <button type="button" className="adm-submit" disabled={savingSalary} onClick={() => saveNewSalaryStructure(employeeId)}>
                  {savingSalary ? "Saving…" : editingSalaryStructureId ? "Save Changes" : "Save Salary Structure"}
                </button>
                <button type="button" className="adm-action-btn" onClick={() => { setShowAddSalaryForm(false); resetNewSalaryForm(); }}>Cancel</button>
                <button type="button" className="adm-action-btn" disabled={pullingSalaryFromContract} onClick={() => pullSalaryFromContract(employeeId)}>
                  {pullingSalaryFromContract ? "Pulling…" : "Pull Salary from Approved Contract"}
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );

  const renderPayrollHistorySection = (employeeId) => (
    <>
      <div className="adm-fieldset-title">Payroll History</div>
      {!employeeId ? (
        <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first to see their payroll history.</div>
      ) : payrollHistory.length === 0 ? (
        <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No payroll history yet — this employee hasn't appeared in a calculated payroll period.</div>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr><th>Month</th><th className="adm-num">Gross</th><th className="adm-num">Deduction</th><th className="adm-num">Net</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {payrollHistory.map(h => {
                const expanded = expandedHistoryEntryId === h.entry_id;
                return (
                  <Fragment key={h.entry_id}>
                    <tr className="clickable"
                        onClick={() => setExpandedHistoryEntryId(expanded ? null : h.entry_id)}>
                      <td>{MONTH_NAMES[h.period_month - 1]} {h.period_year}</td>
                      <td className="adm-num">{h.gross_pay != null ? Number(h.gross_pay).toFixed(3) : "—"}</td>
                      <td className="adm-num">{h.total_deduction != null ? Number(h.total_deduction).toFixed(3) : "—"}</td>
                      <td className="adm-num">{h.net_salary != null ? Number(h.net_salary).toFixed(3) : "—"}</td>
                      <td><Badge label={h.status} type={h.status} colorMap={PAYROLL_HISTORY_STATUS_COLOR} /></td>
                      <td style={{ color: "#6080aa", fontSize: 11 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          {expanded ? "Hide" : "Details"} <IconChevron open={expanded} />
                        </span>
                      </td>
                    </tr>
                    {expanded && (
                      <tr>
                        <td colSpan={6} style={{ background: "#f4f8ff" }}>
                          <div className="adm-form-grid" style={{ padding: "8px 4px" }}>
                            <div><span className="adm-label">Basic Salary</span><div>{h.basic_salary != null ? Number(h.basic_salary).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Fixed Other Amount</span><div>{h.fixed_other_amount != null ? Number(h.fixed_other_amount).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Prorated Basic</span><div>{h.prorated_basic != null ? Number(h.prorated_basic).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Prorated Other</span><div>{h.prorated_other_amount != null ? Number(h.prorated_other_amount).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Working Days</span><div>{h.working_days != null ? h.working_days : "—"}</div></div>
                            <div><span className="adm-label">Additional Amount</span><div>{h.additional_amount != null ? Number(h.additional_amount).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Statutory Deduction</span><div>{h.statutory_deduction != null ? Number(h.statutory_deduction).toFixed(3) : "—"}</div></div>
                            <div><span className="adm-label">Other Deduction</span><div>{h.other_deduction != null ? Number(h.other_deduction).toFixed(3) : "—"}</div></div>
                            {h.deduction_reason && <div><span className="adm-label">Deduction Reason</span><div>{h.deduction_reason}</div></div>}
                            {h.remarks && <div><span className="adm-label">Remarks</span><div>{h.remarks}</div></div>}
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );

  const renderLeaveSection = (employeeId) => {
    if (!employeeId) {
      return (
        <>
          <div className="adm-fieldset-title">Leave Management</div>
          <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first to manage their leave.</div>
        </>
      );
    }
    const annualEntries = leaveEntries.filter(e => e.leave_type === "annual");
    const casualEntries = leaveEntries.filter(e => e.leave_type === "casual");
    return (
      <>
        <div className="adm-fieldset-title">Leave Management</div>

        {leaveSummary && (
          <div className="adm-form-grid" style={{ marginBottom: 16 }}>
            <div><span className="adm-label">Completed Service Months</span><div>{leaveSummary.completed_service_months ?? "—"}</div></div>
            <div><span className="adm-label">Probation End Date</span><div>{leaveSummary.probation_end_date || "—"}</div></div>
            <div><span className="adm-label">Total Annual Leave</span><div>{leaveSummary.total_leaves.toFixed(1)} days</div></div>
            <div><span className="adm-label">Annual Leave Undertaken</span><div>{leaveSummary.annual_leave_undertaken.toFixed(1)} days</div></div>
            <div><span className="adm-label">Available Annual Leave Balance</span>
                 <div style={{ fontWeight: 700, color: leaveSummary.annual_leave_balance < 0 ? "#dc2626" : "#0d1a36" }}>
                   {leaveSummary.annual_leave_balance.toFixed(1)} days
                 </div></div>
          </div>
        )}

        {readOnly ? null : !showAddLeaveForm ? (
          <button type="button" className="adm-action-btn" onClick={() => { resetNewLeaveForm(); setShowAddLeaveForm(true); }}>
            + Add Leave
          </button>
        ) : (
          <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 14 }}>
            <div className="adm-fieldset-title" style={{ fontSize: 11 }}>{editingLeaveEntryId ? "Edit Leave Entry" : "Add Leave Entry"}</div>
            <div className="adm-form-grid">
              {field("Leave Type *", (
                <select className="adm-select" value={newLeaveType} disabled={!!editingLeaveEntryId}
                        onChange={e => setNewLeaveType(e.target.value)}>
                  <option value="annual">Annual Leave</option>
                  <option value="casual">Casual Leave</option>
                </select>
              ))}
              {newLeaveType === "annual" ? (
                <>
                  {field("Start Date *", <input type="date" className="adm-input" value={newLeaveStart} onChange={e => setNewLeaveStart(e.target.value)} />)}
                  {field("End Date *", <input type="date" className="adm-input" value={newLeaveEnd} onChange={e => setNewLeaveEnd(e.target.value)} />)}
                </>
              ) : (
                <>
                  {field("Leave Date *", <input type="date" className="adm-input" value={newLeaveDate} onChange={e => setNewLeaveDate(e.target.value)} />)}
                  {field("Duration *", (
                    <select className="adm-select" value={newLeaveDuration} onChange={e => setNewLeaveDuration(e.target.value)}>
                      <option value="full_day">Full Day (1.0)</option>
                      <option value="half_day">Half Day (0.5)</option>
                    </select>
                  ))}
                </>
              )}
            </div>
            {field("Remarks", <textarea className="adm-input" rows={2} value={newLeaveRemarks} onChange={e => setNewLeaveRemarks(e.target.value)} />)}
            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
              <button type="button" className="adm-submit" disabled={savingLeave} onClick={() => saveLeaveEntry(employeeId)}>
                {savingLeave ? "Saving…" : "Save Leave Entry"}
              </button>
              <button type="button" className="adm-action-btn" onClick={() => { setShowAddLeaveForm(false); resetNewLeaveForm(); }}>Cancel</button>
            </div>
          </div>
        )}

        {[["Annual Leave", annualEntries], ["Casual Leave", casualEntries]].map(([title, list]) => (
          <div key={title} style={{ marginTop: 14 }}>
            <div className="adm-fieldset-title" style={{ fontSize: 12 }}>{title}</div>
            {list.length === 0 ? (
              <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No {title.toLowerCase()} entries yet.</div>
            ) : (
              <div className="adm-table-wrap">
                <table className="adm-table">
                  <thead>
                    <tr><th>{title === "Annual Leave" ? "Dates" : "Date"}</th><th>Days</th><th>Remarks</th><th>Status</th><th></th></tr>
                  </thead>
                  <tbody>
                    {list.map(en => (
                      <tr key={en.id}>
                        <td>{title === "Annual Leave" ? `${en.start_date} to ${en.end_date}` : `${en.leave_date} (${en.duration === "half_day" ? "Half Day" : "Full Day"})`}</td>
                        <td>{en.days}</td>
                        <td>{en.remarks || "—"}</td>
                        <td><Badge label={en.status} type={en.status} colorMap={LEAVE_STATUS_COLOR} /></td>
                        <td style={{ display: "flex", gap: 6 }}>
                          {!readOnly && en.status === "active" && (
                            <>
                              <button type="button" className="adm-action-btn" onClick={() => startEditLeaveEntry(en)}>Edit</button>
                              <button type="button" className="adm-action-btn danger" onClick={() => cancelLeaveEntry(en.id, employeeId)}>Cancel</button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </>
    );
  };

  const PURPOSE_OPTIONS = [
    ["personal_use", "Personal Use"], ["marriage", "Marriage"], ["pilgrimage", "Pilgrimage"],
    ["health", "Health"], ["asset_purchase", "Asset Purchase"], ["others", "Others"],
  ];
  const METHOD_OPTIONS = [
    ["salary_deduction", "Salary Deduction"], ["gratuity", "Gratuity"],
    ["manual_payment", "Manual Payment"], ["mixed", "Mixed"],
  ];
  const FREQUENCY_OPTIONS = [
    ["monthly", "Monthly"], ["one_time", "One-time"], ["on_final_settlement", "On Final Settlement"], ["other", "Other"],
  ];
  const DEDUCTION_SOURCE_OPTIONS = [
    ["salary", "Salary"], ["gratuity", "Gratuity"], ["manual_payment", "Manual Payment"],
    ["adjustment", "Adjustment"], ["other", "Other"],
  ];

  const renderLoansSection = (employeeId) => {
    if (!employeeId) {
      return (
        <>
          <div className="adm-fieldset-title">Loans</div>
          <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first to manage loans.</div>
        </>
      );
    }
    return (
      <>
        <div className="adm-fieldset-title">Loans &amp; Salary Advances</div>

        {readOnly ? null : !showAddLoanForm ? (
          <button type="button" className="adm-action-btn" style={{ marginBottom: 16 }}
                  onClick={() => { resetNewLoanForm(); setShowAddLoanForm(true); }}>
            + Add Loan
          </button>
        ) : (
          <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 14 }}>
            <div className="adm-fieldset-title" style={{ fontSize: 11 }}>Add Loan</div>
            <div className="adm-form-grid">
              {field("Loan Type *", (
                <select className="adm-select" value={newLoanForm.loan_type} onChange={e => setNewLoanForm(p => ({ ...p, loan_type: e.target.value }))}>
                  <option value="loan">Loan</option>
                  <option value="advance_salary">Advance Salary (Running Month)</option>
                </select>
              ))}
              {field("Purpose *", (
                <select className="adm-select" value={newLoanForm.purpose} onChange={e => setNewLoanForm(p => ({ ...p, purpose: e.target.value }))}>
                  <option value="">— Select —</option>
                  {PURPOSE_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              ))}
              {newLoanForm.purpose === "others" &&
                field("Other Purpose *", <input className="adm-input" value={newLoanForm.other_purpose} onChange={e => setNewLoanForm(p => ({ ...p, other_purpose: e.target.value }))} />)}
              {field("Loan Amount *", <input className="adm-input" type="number" step="0.001" min="0" value={newLoanForm.loan_amount} onChange={e => setNewLoanForm(p => ({ ...p, loan_amount: e.target.value }))} />)}
              {field("Entry Date", <input className="adm-input" type="date" value={newLoanForm.entry_date} onChange={e => setNewLoanForm(p => ({ ...p, entry_date: e.target.value }))} />)}
              {field("Guarantor", <input className="adm-input" value={newLoanForm.guarantor} onChange={e => setNewLoanForm(p => ({ ...p, guarantor: e.target.value }))} />)}
            </div>
            {field("Notes", <textarea className="adm-input" rows={2} value={newLoanForm.notes} onChange={e => setNewLoanForm(p => ({ ...p, notes: e.target.value }))} />)}
            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
              <button type="button" className="adm-submit" disabled={savingLoan} onClick={() => saveLoan(employeeId)}>
                {savingLoan ? "Saving…" : "Save Loan"}
              </button>
              <button type="button" className="adm-action-btn" onClick={() => { setShowAddLoanForm(false); resetNewLoanForm(); }}>Cancel</button>
            </div>
          </div>
        )}

        {loans.length === 0 ? (
          <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No loans yet.</div>
        ) : (
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr><th>Loan Type</th><th>Purpose</th><th className="adm-num">Amount</th><th className="adm-num">Deducted</th><th className="adm-num">Balance</th><th>Status</th><th></th></tr>
              </thead>
              <tbody>
                {loans.map(l => {
                  const expanded = expandedLoanId === l.id;
                  return (
                    <Fragment key={l.id}>
                      <tr className="clickable" onClick={() => toggleExpandLoan(l)}>
                        <td>{l.loan_type === "advance_salary" ? "Advance Salary" : "Loan"}</td>
                        <td>{l.purpose === "others" ? l.other_purpose : PURPOSE_OPTIONS.find(([v]) => v === l.purpose)?.[1] || l.purpose}</td>
                        <td className="adm-num">{l.loan_amount.toFixed(3)}</td>
                        <td className="adm-num">{l.total_deducted.toFixed(3)}</td>
                        <td className="adm-num" style={{ fontWeight: 700 }}>{l.balance.toFixed(3)}</td>
                        <td><Badge label={l.status.replace(/_/g, " ")} type={l.status} colorMap={LOAN_STATUS_COLOR} /></td>
                        <td style={{ color: "#6080aa", fontSize: 11 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          {expanded ? "Hide" : "Details"} <IconChevron open={expanded} />
                        </span>
                      </td>
                      </tr>
                      {expanded && (
                        <tr>
                          <td colSpan={7} style={{ background: "#f4f8ff" }}>
                            <div style={{ padding: "10px 4px" }}>

                              {/* ── Repayment Plan ── */}
                              <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Repayment Plan</div>
                              {l.plan_status === "confirmed" ? (
                                <div className="adm-form-grid" style={{ marginBottom: 10 }}>
                                  <div><span className="adm-label">Method</span><div>{METHOD_OPTIONS.find(([v]) => v === l.repayment_method)?.[1] || "—"}</div></div>
                                  <div><span className="adm-label">Instalment Amount</span><div>{l.instalment_amount != null ? l.instalment_amount.toFixed(3) : "—"}</div></div>
                                  <div><span className="adm-label">Frequency</span><div>{FREQUENCY_OPTIONS.find(([v]) => v === l.frequency)?.[1] || "—"}</div></div>
                                  <div><span className="adm-label">Start Date</span><div>{l.plan_start_date || "—"}</div></div>
                                  <div><span className="adm-label">Expected Completion</span><div>{l.expected_completion_date || "—"}</div></div>
                                  {l.special_instructions && <div><span className="adm-label">Special Instructions</span><div>{l.special_instructions}</div></div>}
                                </div>
                              ) : !readOnly && ["draft", "active"].includes(l.status) ? (
                                <div style={{ marginBottom: 14 }}>
                                  {field("Repayment Instruction (natural language)", (
                                    <textarea className="adm-input" rows={2} value={planInstruction}
                                              onChange={e => setPlanInstruction(e.target.value)}
                                              placeholder='e.g. "Deduct OMR 100 per month starting from 1 January 2027."' />
                                  ))}
                                  <button type="button" className="adm-action-btn" disabled={generatingPlan}
                                          onClick={() => generatePlan(l.id, employeeId)}>
                                    {generatingPlan ? "Generating…" : "Generate Plan with AI"}
                                  </button>

                                  {planDraft && (
                                    <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginTop: 10 }}>
                                      <div className="adm-fieldset-title" style={{ fontSize: 11 }}>Review AI-Generated Plan (edit before confirming)</div>
                                      <div className="adm-form-grid">
                                        {field("Repayment Method *", (
                                          <select className="adm-select" value={planDraft.repayment_method || ""}
                                                  onChange={e => setPlanDraft(p => ({ ...p, repayment_method: e.target.value }))}>
                                            <option value="">— Select —</option>
                                            {METHOD_OPTIONS.map(([v, l2]) => <option key={v} value={v}>{l2}</option>)}
                                          </select>
                                        ))}
                                        {field("Instalment Amount", <input className="adm-input" type="number" step="0.001" value={planDraft.instalment_amount || ""} onChange={e => setPlanDraft(p => ({ ...p, instalment_amount: e.target.value }))} />)}
                                        {field("Frequency", (
                                          <select className="adm-select" value={planDraft.frequency || ""} onChange={e => setPlanDraft(p => ({ ...p, frequency: e.target.value }))}>
                                            <option value="">— Select —</option>
                                            {FREQUENCY_OPTIONS.map(([v, l2]) => <option key={v} value={v}>{l2}</option>)}
                                          </select>
                                        ))}
                                        {field("Start Date", <input className="adm-input" type="date" value={planDraft.plan_start_date || ""} onChange={e => setPlanDraft(p => ({ ...p, plan_start_date: e.target.value }))} />)}
                                        {field("Number of Instalments", <input className="adm-input" type="number" min="1" value={planDraft.num_instalments || ""} onChange={e => setPlanDraft(p => ({ ...p, num_instalments: e.target.value }))} />)}
                                        {field("Expected Completion Date", <input className="adm-input" type="date" value={planDraft.expected_completion_date || ""} onChange={e => setPlanDraft(p => ({ ...p, expected_completion_date: e.target.value }))} />)}
                                      </div>
                                      {field("Special Instructions", <textarea className="adm-input" rows={2} value={planDraft.special_instructions || ""} onChange={e => setPlanDraft(p => ({ ...p, special_instructions: e.target.value }))} />)}
                                      <button type="button" className="adm-submit" style={{ marginTop: 10 }} disabled={confirmingPlan}
                                              onClick={() => confirmPlan(l.id, employeeId)}>
                                        {confirmingPlan ? "Confirming…" : "Confirm Plan & Activate Loan"}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No plan confirmed.</div>
                              )}

                              {/* ── Deductions ── */}
                              <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Deductions</div>
                              {!readOnly && l.status === "active" && (
                                !showAddDeductionForm ? (
                                  <button type="button" className="adm-action-btn" onClick={() => { setNewDeductionForm({ ...BLANK_DEDUCTION_FORM }); setShowAddDeductionForm(true); }}>
                                    + Record Deduction
                                  </button>
                                ) : (
                                  <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 10 }}>
                                    <div className="adm-form-grid">
                                      {field("Deduction Date *", <input className="adm-input" type="date" value={newDeductionForm.deduction_date} onChange={e => setNewDeductionForm(p => ({ ...p, deduction_date: e.target.value }))} />)}
                                      {field("Amount *", <input className="adm-input" type="number" step="0.001" min="0" value={newDeductionForm.deduction_amount} onChange={e => setNewDeductionForm(p => ({ ...p, deduction_amount: e.target.value }))} />)}
                                      {field("Source *", (
                                        <select className="adm-select" value={newDeductionForm.source} onChange={e => setNewDeductionForm(p => ({ ...p, source: e.target.value }))}>
                                          {DEDUCTION_SOURCE_OPTIONS.map(([v, l2]) => <option key={v} value={v}>{l2}</option>)}
                                        </select>
                                      ))}
                                      {newDeductionForm.source === "salary" &&
                                        field("Payroll Month * (e.g. Jan-2025)", <input className="adm-input" value={newDeductionForm.payroll_month} onChange={e => setNewDeductionForm(p => ({ ...p, payroll_month: e.target.value }))} />)}
                                      {field("Reference Number", <input className="adm-input" value={newDeductionForm.reference_number} onChange={e => setNewDeductionForm(p => ({ ...p, reference_number: e.target.value }))} />)}
                                    </div>
                                    {field("Remarks", <textarea className="adm-input" rows={2} value={newDeductionForm.remarks} onChange={e => setNewDeductionForm(p => ({ ...p, remarks: e.target.value }))} />)}
                                    <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                                      <button type="button" className="adm-submit" disabled={savingDeduction} onClick={() => recordDeduction(l.id, employeeId)}>
                                        {savingDeduction ? "Saving…" : "Save Deduction"}
                                      </button>
                                      <button type="button" className="adm-action-btn" onClick={() => setShowAddDeductionForm(false)}>Cancel</button>
                                    </div>
                                  </div>
                                )
                              )}
                              {loanDeductions.length === 0 ? (
                                <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No deductions recorded yet.</div>
                              ) : (
                                <div className="adm-table-wrap">
                                  <table className="adm-table">
                                    <thead><tr><th>Date</th><th className="adm-num">Amount</th><th>Source</th><th>Payroll Month</th><th>Remarks</th><th>Status</th><th></th></tr></thead>
                                    <tbody>
                                      {loanDeductions.map(d => (
                                        <tr key={d.id}>
                                          <td>{d.deduction_date}</td>
                                          <td className="adm-num">{d.deduction_amount.toFixed(3)}</td>
                                          <td>{DEDUCTION_SOURCE_OPTIONS.find(([v]) => v === d.source)?.[1] || d.source}</td>
                                          <td>{d.payroll_month || "—"}</td>
                                          <td>{d.remarks || "—"}</td>
                                          <td><Badge label={d.status} type={d.status} colorMap={LOAN_DEDUCTION_STATUS_COLOR} /></td>
                                          <td>
                                            {!readOnly && d.status === "confirmed" && (
                                              <button type="button" className="adm-action-btn danger" onClick={() => reverseDeduction(l.id, d.id, employeeId)}>Reverse</button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}

                              {/* ── Documents ── */}
                              <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Documents</div>
                              {!readOnly && (
                                <div className="adm-field" style={{ maxWidth: 420, marginBottom: 12 }}>
                                  <label className="adm-label">Document Title</label>
                                  <input className="adm-input" list="loan-doc-titles" value={newDocTitle}
                                         onChange={e => setNewDocTitle(e.target.value)} placeholder="Loan Agreement, Receipt, or type a custom title"
                                         style={{ marginBottom: 10 }} />
                                  <label className="adm-label">Upload File</label>
                                  <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" disabled={uploadingDoc}
                                         onChange={e => { const f = e.target.files[0]; if (f) uploadLoanDocument(l.id, f); e.target.value = ""; }} />
                                  {uploadingDoc && <div style={{ fontSize: 11, color: "#0284c7", marginTop: 6 }}>Uploading…</div>}
                                </div>
                              )}
                              <datalist id="loan-doc-titles">
                                {loanDocumentTitles.map(t => <option key={t} value={t} />)}
                              </datalist>
                              {loanDocuments.length === 0 ? (
                                <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No documents uploaded yet.</div>
                              ) : (
                                <div className="adm-table-wrap">
                                  <table className="adm-table">
                                    <thead><tr><th>Title</th><th>File</th><th></th></tr></thead>
                                    <tbody>
                                      {loanDocuments.map(doc => (
                                        <tr key={doc.id}>
                                          <td>{doc.title}</td>
                                          <td>{doc.file_name}</td>
                                          <td style={{ display: "flex", gap: 6 }}>
                                            <button type="button" className="adm-action-btn" onClick={() => viewLoanDocument(doc.id)}>View</button>
                                            {!readOnly && (
                                              <button type="button" className="adm-action-btn danger" onClick={() => deleteLoanDocument(l.id, doc.id)}>Remove</button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}

                              {/* ── Close / Cancel ── */}
                              {!readOnly && (["active", "fully_repaid"].includes(l.status) || ["draft", "active"].includes(l.status)) && (
                                <div style={{ display: "flex", gap: 10, marginTop: 18, paddingTop: 14, borderTop: "1px solid #d5e3f5" }}>
                                  {["active", "fully_repaid"].includes(l.status) && (
                                    <button type="button" className="adm-btn-secondary" onClick={() => closeLoan(l.id, employeeId)}>Close Loan</button>
                                  )}
                                  {["draft", "active"].includes(l.status) && (
                                    <button type="button" className="adm-btn-secondary" style={{ borderColor: "rgba(220,38,38,.4)", color: "#dc2626" }}
                                            onClick={() => cancelLoan(l.id, employeeId)}>Cancel Loan</button>
                                  )}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  };

  const VEHICLE_CONDITIONS = [["new", "New"], ["good", "Good"], ["fair", "Fair"], ["damaged", "Damaged"]];
  const LICENCE_TYPE_OPTIONS = [
    ["per_user", "Per User"], ["per_device", "Per Device"], ["concurrent", "Concurrent"],
    ["named_user", "Named User"], ["site", "Site"], ["saas_subscription", "SaaS Subscription"], ["other", "Other"],
  ];
  const OFFBOARDING_ACTION_OPTIONS = [
    ["deactivate", "Deactivate"], ["remove_seat", "Remove Seat"], ["reassign", "Reassign"],
    ["retain_with_approval", "Retain with Approval"], ["no_action", "No Action"],
  ];
  const RELOCATION_TYPE_OPTIONS = [
    ["employee_transfer", "Employee Transfer"], ["location_change", "Location Change"],
    ["department_transfer", "Department Transfer"], ["return_to_store", "Return to Store"],
  ];

  // Renders a set of visible-but-disabled fields for whichever optional
  // (Mandatory=No) parameters apply — per the boss's instruction, these
  // exist on the form as a placeholder for a future release, carry no
  // state, and are never part of any save payload.
  const renderPlaceholderFields = (labels) => (
    <div className="adm-form-grid">
      {labels.map(label => (
        <div className="adm-field" key={label}>
          <label className="adm-label">{label}</label>
          <input className="adm-input" disabled placeholder="Coming in a future release" title="Coming in a future release" />
        </div>
      ))}
    </div>
  );

  const renderAssetsSection = (employeeId) => {
    if (!employeeId) {
      return (
        <>
          <div className="adm-fieldset-title">Assets</div>
          <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>Save the employee first to manage assets.</div>
        </>
      );
    }
    return (
      <>
        <div className="adm-fieldset-title">Asset Management</div>

        {readOnly ? null : !showAddAssetForm ? (
          <button type="button" className="adm-action-btn" style={{ marginBottom: 16 }}
                  onClick={() => { resetNewAssetForm(); setShowAddAssetForm(true); }}>
            + Add Asset
          </button>
        ) : (
          <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 14 }}>
            <div className="adm-fieldset-title" style={{ fontSize: 11 }}>{editingAssetId ? "Edit Asset" : "Add Asset"}</div>
            <div className="adm-form-grid">
              {field("Type *", (
                <select className="adm-select" value={newAssetForm.asset_type} disabled={!!editingAssetId}
                        title={editingAssetId ? "Asset type can't be changed after creation" : undefined}
                        onChange={e => setNewAssetForm(p => ({ ...p, asset_type: e.target.value }))}>
                  <option value="vehicle">Vehicle</option>
                  <option value="hardware">Hardware</option>
                  <option value="software">Software</option>
                </select>
              ))}
              {newAssetForm.asset_type !== "software" &&
                field("Current Location *", <input className="adm-input" value={newAssetForm.current_location} onChange={e => setNewAssetForm(p => ({ ...p, current_location: e.target.value }))} />)}
            </div>

            {newAssetForm.asset_type === "vehicle" && (
              <>
                <div className="adm-fieldset-title" style={{ fontSize: 11, marginTop: 14 }}>Vehicle Details</div>
                <div className="adm-field" style={{ maxWidth: 420, marginBottom: 12 }}>
                  <label className="adm-label">Upload Mulkiya (auto-fills the fields below)</label>
                  <input key={mulkiyaInputKey} type="file" accept=".pdf,.jpg,.jpeg,.png" disabled={readingMulkiya}
                         onChange={e => handleMulkiyaChosen(e.target.files[0] || null)} />
                  {readingMulkiya && <div style={{ fontSize: 11, color: "#0284c7", marginTop: 6 }}>Reading document…</div>}
                </div>
                <div className="adm-form-grid">
                  {field("Registration / Plate Number *", <input className="adm-input" value={newAssetForm.vehicle.registration_number} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, registration_number: e.target.value } }))} />)}
                  {field("Chassis / VIN Number *", <input className="adm-input" value={newAssetForm.vehicle.chassis_vin} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, chassis_vin: e.target.value } }))} />)}
                  {field("Make *", <input className="adm-input" value={newAssetForm.vehicle.make} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, make: e.target.value } }))} />)}
                  {field("Model *", <input className="adm-input" value={newAssetForm.vehicle.model} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, model: e.target.value } }))} />)}
                  {field("Insurance Provider *", <input className="adm-input" value={newAssetForm.vehicle.insurance_provider} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, insurance_provider: e.target.value } }))} />)}
                  {newAssetForm.vehicle.insurance_provider.trim() && (
                    <>
                      {field("Insurance Policy Number *", <input className="adm-input" value={newAssetForm.vehicle.insurance_policy_number} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, insurance_policy_number: e.target.value } }))} />)}
                      {field("Insurance Expiry Date *", <input className="adm-input" type="date" value={newAssetForm.vehicle.insurance_expiry_date} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, insurance_expiry_date: e.target.value } }))} />)}
                    </>
                  )}
                  {field("Registration Expiry Date *", <input className="adm-input" type="date" value={newAssetForm.vehicle.registration_expiry_date} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, registration_expiry_date: e.target.value } }))} />)}
                  {field("Condition at Issue *", (
                    <select className="adm-select" value={newAssetForm.vehicle.condition_at_issue} onChange={e => setNewAssetForm(p => ({ ...p, vehicle: { ...p.vehicle, condition_at_issue: e.target.value } }))}>
                      {VEHICLE_CONDITIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  ))}
                </div>
              </>
            )}

            {newAssetForm.asset_type === "hardware" && (
              <>
                <div className="adm-fieldset-title" style={{ fontSize: 11, marginTop: 14 }}>Hardware Details</div>
                <div className="adm-form-grid">
                  {field("Hardware Category *", <input className="adm-input" value={newAssetForm.hardware.hardware_category} onChange={e => setNewAssetForm(p => ({ ...p, hardware: { ...p.hardware, hardware_category: e.target.value } }))} placeholder="e.g. Laptop, Mobile" />)}
                  {field("Manufacturer *", <input className="adm-input" value={newAssetForm.hardware.manufacturer} onChange={e => setNewAssetForm(p => ({ ...p, hardware: { ...p.hardware, manufacturer: e.target.value } }))} />)}
                  {field("Model *", <input className="adm-input" value={newAssetForm.hardware.model} onChange={e => setNewAssetForm(p => ({ ...p, hardware: { ...p.hardware, model: e.target.value } }))} />)}
                  {field("Serial Number / IMEI *", <input className="adm-input" value={newAssetForm.hardware.serial_or_imei} onChange={e => setNewAssetForm(p => ({ ...p, hardware: { ...p.hardware, serial_or_imei: e.target.value } }))} />)}
                  {field("Condition at Issue *", (
                    <select className="adm-select" value={newAssetForm.hardware.condition_at_issue} onChange={e => setNewAssetForm(p => ({ ...p, hardware: { ...p.hardware, condition_at_issue: e.target.value } }))}>
                      {VEHICLE_CONDITIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  ))}
                </div>
              </>
            )}

            {newAssetForm.asset_type === "software" && (
              <>
                <div className="adm-fieldset-title" style={{ fontSize: 11, marginTop: 14 }}>Software Details</div>
                <div className="adm-form-grid">
                  {field("Software / Service Name *", <input className="adm-input" value={newAssetForm.software.software_name} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, software_name: e.target.value } }))} />)}
                  {field("Licence / Subscription Type *", (
                    <select className="adm-select" value={newAssetForm.software.licence_type} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, licence_type: e.target.value } }))}>
                      <option value="">— Select —</option>
                      {LICENCE_TYPE_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  ))}
                  {field("Vendor / Provider *", <input className="adm-input" value={newAssetForm.software.vendor} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, vendor: e.target.value } }))} placeholder="e.g. Microsoft, Adobe" />)}
                  {field("Assigned Account / Login Email *", <input className="adm-input" type="email" value={newAssetForm.software.assigned_account_email} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, assigned_account_email: e.target.value } }))} />)}
                  {field("Start / Activation Date *", <input className="adm-input" type="date" value={newAssetForm.software.software_start_date} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, software_start_date: e.target.value } }))} />)}
                  {field("Auto-Renewal *", (
                    <select className="adm-select" value={newAssetForm.software.auto_renewal ? "yes" : "no"} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, auto_renewal: e.target.value === "yes" } }))}>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  ))}
                  {newAssetForm.software.auto_renewal &&
                    field("Renewal Date *", <input className="adm-input" type="date" value={newAssetForm.software.renewal_date} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, renewal_date: e.target.value } }))} />)}
                  {field("Administrative Owner *", <input className="adm-input" value={newAssetForm.software.admin_owner} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, admin_owner: e.target.value } }))} />)}
                  {field("SSO / Identity Provider Managed *", (
                    <select className="adm-select" value={newAssetForm.software.sso_managed ? "yes" : "no"} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, sso_managed: e.target.value === "yes" } }))}>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  ))}
                  {field("Offboarding Action *", (
                    <select className="adm-select" value={newAssetForm.software.offboarding_action} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, offboarding_action: e.target.value } }))}>
                      {OFFBOARDING_ACTION_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                    </select>
                  ))}
                  {["retain_with_approval", "no_action"].includes(newAssetForm.software.offboarding_action) && (
                    <>
                      {field("Offboarding Reason *", <input className="adm-input" value={newAssetForm.software.offboarding_reason} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, offboarding_reason: e.target.value } }))} />)}
                      {field("Offboarding Approver *", <input className="adm-input" value={newAssetForm.software.offboarding_approver} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, offboarding_approver: e.target.value } }))} />)}
                    </>
                  )}
                  {field("Recoverable / Reusable Licence *", (
                    <select className="adm-select" value={newAssetForm.software.recoverable_licence ? "yes" : "no"} onChange={e => setNewAssetForm(p => ({ ...p, software: { ...p.software, recoverable_licence: e.target.value === "yes" } }))}>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  ))}
                </div>
              </>
            )}

            <button type="button" className="adm-action-btn" style={{ marginTop: 14, display: "inline-flex", alignItems: "center", gap: 5 }}
                    onClick={() => setShowAssetPlaceholders(p => !p)}>
              {showAssetPlaceholders ? "Hide" : "Show"} additional fields (coming in a future release) <IconChevron open={showAssetPlaceholders} />
            </button>
            {showAssetPlaceholders && (
              <div style={{ marginTop: 10 }}>
                {renderPlaceholderFields(PLACEHOLDER_FIELDS.common)}
                {newAssetForm.asset_type === "vehicle" && renderPlaceholderFields(PLACEHOLDER_FIELDS.vehicle)}
                {newAssetForm.asset_type === "hardware" && renderPlaceholderFields(PLACEHOLDER_FIELDS.hardware)}
                {newAssetForm.asset_type === "software" && renderPlaceholderFields(PLACEHOLDER_FIELDS.software)}
              </div>
            )}

            <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
              <button type="button" className="adm-submit" disabled={savingAsset} onClick={() => saveAsset(employeeId)}>
                {savingAsset ? "Saving…" : editingAssetId ? "Save Changes" : "Save Asset"}
              </button>
              <button type="button" className="adm-action-btn" onClick={() => { setShowAddAssetForm(false); resetNewAssetForm(); }}>Cancel</button>
            </div>
          </div>
        )}

        {assets.length === 0 ? (
          <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No assets yet.</div>
        ) : (
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr><th>Asset Code</th><th>Type</th><th>Title</th><th>Category</th><th>Status</th><th>Location</th><th></th><th></th></tr>
              </thead>
              <tbody>
                {assets.map(a => {
                  const expanded = expandedAssetId === a.id;
                  return (
                    <Fragment key={a.id}>
                      <tr className="clickable" onClick={() => toggleExpandAsset(a)}>
                        <td>{a.asset_code}</td>
                        <td style={{ textTransform: "capitalize" }}>{a.asset_type}</td>
                        <td>{a.asset_title}</td>
                        <td>{a.category}</td>
                        <td><Badge label={a.status.replace(/_/g, " ")} type={a.status} colorMap={ASSET_STATUS_COLOR} /></td>
                        <td>{a.current_location || "—"}</td>
                        <td style={{ color: "#6080aa", fontSize: 11 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          {expanded ? "Hide" : "Details"} <IconChevron open={expanded} />
                        </span>
                      </td>
                        <td>
                          {!readOnly && (
                            <div className="adm-row-actions" onClick={e => e.stopPropagation()}>
                              <button type="button" className="adm-icon-btn" title="Edit" onClick={() => startEditAsset(a)}><IconEdit /></button>
                              <button type="button" className="adm-icon-btn danger" title="Delete" onClick={() => deleteAsset(a)}><IconTrash /></button>
                            </div>
                          )}
                        </td>
                      </tr>
                      {expanded && (
                        <tr>
                          <td colSpan={8} style={{ background: "#f4f8ff" }}>
                            <div style={{ padding: "10px 4px" }}>

                              {a.asset_type === "vehicle" && (
                                <div className="adm-form-grid" style={{ marginBottom: 14 }}>
                                  <div><span className="adm-label">Registration</span><div>{a.registration_number}</div></div>
                                  <div><span className="adm-label">VIN</span><div>{a.chassis_vin}</div></div>
                                  <div><span className="adm-label">Make / Model</span><div>{a.make} {a.model}</div></div>
                                  <div><span className="adm-label">Insurance</span><div>{a.insurance_provider} ({a.insurance_policy_number})</div></div>
                                  <div><span className="adm-label">Insurance Expiry</span><div>{a.insurance_expiry_date || "—"}</div></div>
                                  <div><span className="adm-label">Registration Expiry</span><div>{a.registration_expiry_date || "—"}</div></div>
                                  <div><span className="adm-label">Condition at Issue</span><div style={{ textTransform: "capitalize" }}>{a.condition_at_issue}</div></div>
                                </div>
                              )}
                              {a.asset_type === "hardware" && (
                                <div className="adm-form-grid" style={{ marginBottom: 14 }}>
                                  <div><span className="adm-label">Category</span><div>{a.hardware_category}</div></div>
                                  <div><span className="adm-label">Manufacturer / Model</span><div>{a.manufacturer} {a.model}</div></div>
                                  <div><span className="adm-label">Serial / IMEI</span><div>{a.serial_or_imei}</div></div>
                                  <div><span className="adm-label">Condition at Issue</span><div style={{ textTransform: "capitalize" }}>{a.condition_at_issue}</div></div>
                                </div>
                              )}
                              {a.asset_type === "software" && (
                                <>
                                  <div className="adm-form-grid" style={{ marginBottom: 10 }}>
                                    <div><span className="adm-label">Vendor</span><div>{a.vendor}</div></div>
                                    <div><span className="adm-label">Licence Type</span><div style={{ textTransform: "capitalize" }}>{(a.licence_type || "").replace(/_/g, " ")}</div></div>
                                    <div><span className="adm-label">Assigned Account</span><div>{a.assigned_account_email}</div></div>
                                    <div><span className="adm-label">Start Date</span><div>{a.software_start_date}</div></div>
                                    <div><span className="adm-label">Auto-Renewal</span><div>{a.auto_renewal ? `Yes (${a.renewal_date || "—"})` : "No"}</div></div>
                                    <div><span className="adm-label">Admin Owner</span><div>{a.admin_owner}</div></div>
                                    <div><span className="adm-label">SSO Managed</span><div>{a.sso_managed ? "Yes" : "No"}</div></div>
                                    <div><span className="adm-label">Offboarding Action</span><div style={{ textTransform: "capitalize" }}>{(a.offboarding_action || "").replace(/_/g, " ")}</div></div>
                                    <div><span className="adm-label">Deactivation Status</span><div><Badge label={a.deactivation_status.replace(/_/g, " ")} type={a.deactivation_status} colorMap={DEACTIVATION_STATUS_COLOR} /></div></div>
                                  </div>
                                  {a.deactivation_status !== "completed" && (
                                    readOnly ? null : !showDeactivateForm ? (
                                      <button type="button" className="adm-action-btn" onClick={() => setShowDeactivateForm(true)}>Deactivate Licence</button>
                                    ) : (
                                      <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 10 }}>
                                        {field("Completion Evidence *", <input className="adm-input" value={deactivateEvidence} onChange={e => setDeactivateEvidence(e.target.value)} placeholder="Ticket ID, confirmation reference, etc." />)}
                                        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                                          <button type="button" className="adm-submit" disabled={savingDeactivate} onClick={() => deactivateSoftwareAsset(a.id, employeeId)}>
                                            {savingDeactivate ? "Deactivating…" : "Confirm Deactivation"}
                                          </button>
                                          <button type="button" className="adm-action-btn" onClick={() => setShowDeactivateForm(false)}>Cancel</button>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </>
                              )}

                              {["vehicle", "hardware"].includes(a.asset_type) && (
                                <div style={{ marginBottom: 14 }}>
                                  <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Relocation</div>
                                  {readOnly ? null : !showRelocateForm ? (
                                    <button type="button" className="adm-action-btn" onClick={() => { setRelocateForm({ ...BLANK_RELOCATE_FORM }); setShowRelocateForm(true); }}>
                                      Relocate Asset
                                    </button>
                                  ) : (
                                    <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, marginBottom: 10 }}>
                                      <div className="adm-form-grid">
                                        {field("Relocation Type *", (
                                          <select className="adm-select" value={relocateForm.relocation_type} onChange={e => setRelocateForm(p => ({ ...p, relocation_type: e.target.value }))}>
                                            {RELOCATION_TYPE_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                          </select>
                                        ))}
                                        {relocateForm.relocation_type === "employee_transfer" &&
                                          field("To Employee *", (
                                            <select className="adm-select" value={relocateForm.to_employee_id} onChange={e => setRelocateForm(p => ({ ...p, to_employee_id: e.target.value }))}>
                                              <option value="">— Select —</option>
                                              {employees.filter(e => e.id !== employeeId).map(e => <option key={e.id} value={e.id}>{e.employee_code} — {e.full_name}</option>)}
                                            </select>
                                          ))}
                                        {["location_change", "return_to_store"].includes(relocateForm.relocation_type) &&
                                          field("To Location *", <input className="adm-input" value={relocateForm.to_location} onChange={e => setRelocateForm(p => ({ ...p, to_location: e.target.value }))} />)}
                                        {field("Effective Date *", <input className="adm-input" type="date" value={relocateForm.effective_date} onChange={e => setRelocateForm(p => ({ ...p, effective_date: e.target.value }))} />)}
                                        {field("Reason *", <input className="adm-input" value={relocateForm.reason} onChange={e => setRelocateForm(p => ({ ...p, reason: e.target.value }))} placeholder="e.g. Role Change, Site Change, Repair" />)}
                                        {field("Condition at Handover *", (
                                          <select className="adm-select" value={relocateForm.condition_at_handover} onChange={e => setRelocateForm(p => ({ ...p, condition_at_handover: e.target.value }))}>
                                            {VEHICLE_CONDITIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                          </select>
                                        ))}
                                        {field("Approved By", <input className="adm-input" value={relocateForm.approved_by} onChange={e => setRelocateForm(p => ({ ...p, approved_by: e.target.value }))} />)}
                                      </div>
                                      <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                                        <button type="button" className="adm-submit" disabled={savingRelocate} onClick={() => relocateAsset(a.id, employeeId)}>
                                          {savingRelocate ? "Saving…" : "Confirm Relocation"}
                                        </button>
                                        <button type="button" className="adm-action-btn" onClick={() => setShowRelocateForm(false)}>Cancel</button>
                                      </div>
                                    </div>
                                  )}
                                  {assetRelocations.length > 0 && (
                                    <div className="adm-table-wrap">
                                      <table className="adm-table">
                                        <thead><tr><th>Date</th><th>Type</th><th>To Location</th><th>Reason</th><th>Condition</th></tr></thead>
                                        <tbody>
                                          {assetRelocations.map(rel => (
                                            <tr key={rel.id}>
                                              <td>{rel.effective_date.slice(0, 10)}</td>
                                              <td style={{ textTransform: "capitalize" }}>{rel.relocation_type.replace(/_/g, " ")}</td>
                                              <td>{rel.to_location || "—"}</td>
                                              <td>{rel.reason}</td>
                                              <td style={{ textTransform: "capitalize" }}>{rel.condition_at_handover}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </div>
                              )}

                              <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Documents</div>
                              {!readOnly && (
                                <div className="adm-field" style={{ maxWidth: 420, marginBottom: 12 }}>
                                  <label className="adm-label">Document Title</label>
                                  <input className="adm-input" list="asset-doc-titles" value={newAssetDocTitle}
                                         onChange={e => setNewAssetDocTitle(e.target.value)} placeholder="Choose a suggested title or type a custom one"
                                         style={{ marginBottom: 10 }} />
                                  <label className="adm-label">Upload File</label>
                                  <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" disabled={uploadingAssetDoc}
                                         onChange={e => { const f = e.target.files[0]; if (f) uploadAssetDocument(a.id, f); e.target.value = ""; }} />
                                  {uploadingAssetDoc && <div style={{ fontSize: 11, color: "#0284c7", marginTop: 6 }}>Uploading…</div>}
                                </div>
                              )}
                              <datalist id="asset-doc-titles">
                                {assetDocumentTitles.map(t => <option key={t} value={t} />)}
                              </datalist>
                              {assetDocuments.length === 0 ? (
                                <div style={{ fontSize: 12, color: "#6080aa", marginBottom: 10 }}>No documents uploaded yet.</div>
                              ) : (
                                <div className="adm-table-wrap">
                                  <table className="adm-table">
                                    <thead><tr><th>Title</th><th>File</th><th></th></tr></thead>
                                    <tbody>
                                      {assetDocuments.map(doc => (
                                        <tr key={doc.id}>
                                          <td>{doc.title}</td>
                                          <td>{doc.file_name}</td>
                                          <td style={{ display: "flex", gap: 6 }}>
                                            <button type="button" className="adm-action-btn" onClick={() => viewAssetDocument(doc.id)}>View</button>
                                            {!readOnly && (
                                              <button type="button" className="adm-action-btn danger" onClick={() => deleteAssetDocument(a.id, doc.id)}>Remove</button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  };

  const renderOffboardingPanel = (employeeId) => {
    if (!employeeId) return null;
    return (
      <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid #d5e3f5" }}>
        <div className="adm-fieldset-title" style={{ fontSize: 12 }}>Asset Offboarding</div>
        {offboardingClearance?.clearance === "not_started" || !offboardingClearance ? (
          !showStartOffboarding ? (
            readOnly ? <div style={{ fontSize: 12, color: "#6080aa" }}>Not started</div> :
            <button type="button" className="adm-action-btn" onClick={() => setShowStartOffboarding(true)}>Start Offboarding</button>
          ) : (
            <div style={{ border: "1px dashed #c0d0eb", borderRadius: 7, padding: 12, maxWidth: 420 }}>
              {field("Last Working Day *", <input className="adm-input" type="date" value={offboardingLastDay} onChange={e => setOffboardingLastDay(e.target.value)} />)}
              <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                <button type="button" className="adm-submit" disabled={savingOffboarding} onClick={() => startOffboarding(employeeId)}>
                  {savingOffboarding ? "Starting…" : "Confirm & Start Offboarding"}
                </button>
                <button type="button" className="adm-action-btn" onClick={() => setShowStartOffboarding(false)}>Cancel</button>
              </div>
            </div>
          )
        ) : (
          <>
            <div style={{ marginBottom: 10 }}>
              <span className="adm-label">Clearance Status</span>
              <div><Badge label={offboardingClearance.clearance} type={offboardingClearance.clearance === "cleared" ? "completed" : "pending"} colorMap={OFFBOARDING_TASK_STATUS_COLOR} /></div>
            </div>
            <div className="adm-table-wrap">
              <table className="adm-table">
                <thead><tr><th>Task</th><th>Status</th><th>Exception Reason</th><th></th></tr></thead>
                <tbody>
                  {offboardingClearance.tasks.map(t => (
                    <tr key={t.id}>
                      <td style={{ textTransform: "capitalize" }}>{t.task_type}</td>
                      <td><Badge label={t.status.replace(/_/g, " ")} type={t.status} colorMap={OFFBOARDING_TASK_STATUS_COLOR} /></td>
                      <td>{t.exception_reason || "—"}</td>
                      <td style={{ display: "flex", gap: 6 }}>
                        {!readOnly && t.status === "pending" && (
                          <>
                            <button type="button" className="adm-action-btn" onClick={() => completeOffboardingTask(t.id, employeeId)}>Complete</button>
                            <button type="button" className="adm-action-btn danger" onClick={() => exceptionOffboardingTask(t.id, employeeId)}>Exception</button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderForm = (form, setForm, onSave, submitLabel) => {
    const isAdd = submitLabel !== "Save Changes";
    const tabs = [
      { key: "documents", label: "Documents" },
      { key: "personal", label: "Personal" },
      { key: "contact", label: "Contact" },
      { key: "employment", label: "Employment" },
      ...(isAdd ? [{ key: "emergency", label: "Emergency Contact" }] : []),
      { key: "banking", label: "Banking" },
      { key: "salary", label: "Salary" },
      { key: "payroll_history", label: "Payroll History" },
      // LV-AT-003: Leave Management must not appear at all for an Omani
      // employee — not merely disabled, left out of the tab list entirely.
      ...(isEligibleForLeave(form.nationality) ? [{ key: "leave", label: "Leave Management" }] : []),
      // Loans/Assets have no eligibility gate — always shown, unlike Leave.
      { key: "loans", label: "Loans" },
      { key: "assets", label: "Assets" },
    ];
    // Banking/Salary/Payroll History/Leave/Loans/Assets need a real
    // employee_id to exist — grey them out (and skip them in Back/Next)
    // until the employee has actually been created.
    const hasEmployeeId = !!form.id;
    const tabEnabled = (key) => !(["banking", "salary", "payroll_history", "leave", "loans", "assets"].includes(key) && !hasEmployeeId);
    const enabledTabs = tabs.filter(t => tabEnabled(t.key));
    const tabIdx = enabledTabs.findIndex(t => t.key === formTab);
    return (
    <div className="adm-inline-form">
      <div className="adm-inline-form-title">{readOnly ? `View — ${form.full_name}` : submitLabel === "Save Changes" ? `Edit — ${form.full_name}` : "Create Employee"}</div>

      <div className="adm-form-grid" style={{ marginBottom: 14 }}>
        {field("Full Name *", <input className="adm-input" disabled={readOnly} value={form.full_name || ""} onChange={e => setForm(p => ({ ...p, full_name: e.target.value }))} />)}
        {field("Arabic Name", <input className="adm-input" disabled={readOnly} value={form.full_name_arabic || ""} onChange={e => setForm(p => ({ ...p, full_name_arabic: e.target.value }))} />)}
      </div>

      {dupWarning && (
        <div className="adm-warning">
          <strong>Possible duplicate employee:</strong>
          <ul style={{ margin: "6px 0 0 18px" }}>
            {dupWarning.duplicates.map(d => (
              <li key={d.id}>{d.employee_code} — {d.full_name} (matched on {d.match_reason.replace(/_/g, " ")})</li>
            ))}
          </ul>
          <button className="adm-submit" style={{ marginTop: 10, background: "#b45309" }} disabled={savingEmployee}
                  onClick={() => saveNewEmployee(true)}>{savingEmployee ? "Saving…" : "Create Anyway"}</button>
        </div>
      )}

      <div className="adm-tabs" style={{ margin: "0 0 14px", padding: 0 }}>
        {tabs.map(t => {
          const enabled = tabEnabled(t.key);
          return (
            <button key={t.key} type="button" disabled={!enabled}
                    className={`adm-tab${formTab === t.key ? " active" : ""}`}
                    style={enabled ? undefined : { opacity: 0.4, cursor: "not-allowed" }}
                    title={enabled ? undefined : "Save the employee first to unlock this tab"}
                    onClick={() => { if (enabled) setFormTab(t.key); }}>
              {t.label}
            </button>
          );
        })}
      </div>

      {formTab === "documents" && renderDocumentsSection(form.id || null)}

      {formTab === "personal" && (
        <>
          <div className="adm-form-grid">
            {field("Civil ID Number", <input className="adm-input" disabled={readOnly} value={form.civil_id_number || ""} onChange={e => setForm(p => ({ ...p, civil_id_number: e.target.value }))} />)}
            {field("Passport Number", <input className="adm-input" disabled={readOnly} value={form.passport_number || ""} onChange={e => setForm(p => ({ ...p, passport_number: e.target.value }))} />)}
            {field("Foreign ID Number", <input className="adm-input" disabled={readOnly} value={form.foreign_id_number || ""} onChange={e => setForm(p => ({ ...p, foreign_id_number: e.target.value }))} />)}
            {field("Nationality", <input className="adm-input" disabled={readOnly} value={form.nationality || ""} onChange={e => setForm(p => ({ ...p, nationality: e.target.value }))} />)}
            {field("Date of Birth", <input className="adm-input" disabled={readOnly} type="date" value={form.date_of_birth || ""} onChange={e => setForm(p => ({ ...p, date_of_birth: e.target.value }))} />)}
            {field("Gender", (
              <select className="adm-select" disabled={readOnly} value={form.gender || ""} onChange={e => setForm(p => ({ ...p, gender: e.target.value }))}>
                <option value="">— Select —</option>
                {(enums.gender || []).map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            ))}
            {field("Primary ID Type", (
              <select className="adm-select" disabled={readOnly} value={form.primary_id_type || ""} onChange={e => setForm(p => ({ ...p, primary_id_type: e.target.value }))}>
                <option value="">— Select —</option>
                <option value="civil_id">Civil ID</option>
                <option value="passport">Passport</option>
                <option value="foreign_id">Foreign ID</option>
              </select>
            ))}
            {field("Country of Residence", <input className="adm-input" disabled={readOnly} value={form.country_of_residence || ""} onChange={e => setForm(p => ({ ...p, country_of_residence: e.target.value }))} />)}
            {field("Marital Status", (
              <select className="adm-select" disabled={readOnly} value={form.marital_status || ""} onChange={e => setForm(p => ({ ...p, marital_status: e.target.value }))}>
                <option value="">— Select —</option>
                {(enums.marital_status || []).map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            ))}
          </div>
          {!form.civil_id_number && !form.passport_number && !form.foreign_id_number && (
            <div style={{ fontSize: 11, color: "#b45309", marginTop: 6 }}>
              No ID document entered yet — this employee will stay in "draft" status until one is added.
            </div>
          )}
        </>
      )}

      {formTab === "contact" && (
        <div className="adm-form-grid">
          {field("Primary Mobile Country Code", countryCodeSelect(form.primary_mobile_country_code, e => setForm(p => ({ ...p, primary_mobile_country_code: e.target.value })), readOnly))}
          {field("Primary Mobile Number", <input className="adm-input" disabled={readOnly} value={form.primary_mobile_number || ""} onChange={e => setForm(p => ({ ...p, primary_mobile_number: e.target.value }))} />)}
          {field("Secondary Mobile Country Code", countryCodeSelect(form.secondary_mobile_country_code, e => setForm(p => ({ ...p, secondary_mobile_country_code: e.target.value })), readOnly))}
          {field("Secondary Mobile Number", <input className="adm-input" disabled={readOnly} value={form.secondary_mobile_number || ""} onChange={e => setForm(p => ({ ...p, secondary_mobile_number: e.target.value }))} />)}
          {field("Personal Email", <input className="adm-input" disabled={readOnly} type="email" value={form.personal_email || ""} onChange={e => setForm(p => ({ ...p, personal_email: e.target.value }))} />)}
          {field("Company Email", <input className="adm-input" disabled={readOnly} type="email" value={form.company_email || ""} onChange={e => setForm(p => ({ ...p, company_email: e.target.value }))} />)}
          {field("City", <input className="adm-input" disabled={readOnly} value={form.city || ""} onChange={e => setForm(p => ({ ...p, city: e.target.value }))} />)}
          {field("Country", <input className="adm-input" disabled={readOnly} value={form.country || ""} onChange={e => setForm(p => ({ ...p, country: e.target.value }))} />)}
          {field("Postal Code", <input className="adm-input" disabled={readOnly} value={form.postal_code || ""} onChange={e => setForm(p => ({ ...p, postal_code: e.target.value }))} />)}
          {field("Residential Address", <textarea className="adm-input" disabled={readOnly} rows={2} value={form.residential_address || ""} onChange={e => setForm(p => ({ ...p, residential_address: e.target.value }))} />)}
          {field("Permanent Address", <textarea className="adm-input" disabled={readOnly} rows={2} value={form.permanent_address || ""} onChange={e => setForm(p => ({ ...p, permanent_address: e.target.value }))} />)}
        </div>
      )}

      {formTab === "employment" && (
        <div className="adm-form-grid">
          {field("Classification *", (
            <select className="adm-select" disabled={readOnly} value={form.classification || ""} onChange={e => setForm(p => ({ ...p, classification: e.target.value }))}>
              <option value="">— Select —</option>
              {(enums.classification || []).map(c => <option key={c} value={c}>{c.replace(/_/g, " ")}</option>)}
            </select>
          ))}
          {field("Employment Status", (
            <>
              <select className="adm-select" disabled={readOnly} value={form.employment_status || "draft"} onChange={e => setForm(p => ({ ...p, employment_status: e.target.value }))}>
                {(enums.employment_status || []).map(s => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
              </select>
              {form.employment_status && form.employment_status !== "draft" &&
                !form.civil_id_number && !form.passport_number && !form.foreign_id_number && (
                  <span className="adm-status-warning">Will be saved as Draft — no Civil ID, Passport, or Foreign ID entered yet</span>
              )}
            </>
          ))}
          {field("Employee Type", (
            <select className="adm-select" disabled={readOnly} value={form.employee_type || ""} onChange={e => setForm(p => ({ ...p, employee_type: e.target.value }))}>
              <option value="">— Select —</option>
              {(enums.employee_type || []).map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          ))}
          {field("Joining Date", <input className="adm-input" disabled={readOnly} type="date" value={form.joining_date || ""} onChange={e => setForm(p => ({ ...p, joining_date: e.target.value }))} />)}
          {field("Department", <input className="adm-input" disabled={readOnly} value={form.department || ""} onChange={e => setForm(p => ({ ...p, department: e.target.value }))} />)}
          {field("Designation", <input className="adm-input" disabled={readOnly} value={form.designation || ""} onChange={e => setForm(p => ({ ...p, designation: e.target.value }))} />)}
          {field("Branch / Location", <input className="adm-input" disabled={readOnly} value={form.branch_location || ""} onChange={e => setForm(p => ({ ...p, branch_location: e.target.value }))} />)}
          {field("Reporting Manager", (
            <select className="adm-select" disabled={readOnly} value={form.reporting_manager_id || ""} onChange={e => setForm(p => ({ ...p, reporting_manager_id: e.target.value }))}>
              <option value="">— None —</option>
              {employees.filter(e => e.id !== form.id).map(e => <option key={e.id} value={e.id}>{e.employee_code} — {e.full_name}</option>)}
            </select>
          ))}
          {field("Contract Start Date", <input className="adm-input" disabled={readOnly} type="date" value={form.contract_start_date || ""} onChange={e => setForm(p => ({ ...p, contract_start_date: e.target.value }))} />)}
          {field("Contract End Date", <input className="adm-input" disabled={readOnly} type="date" value={form.contract_end_date || ""} onChange={e => setForm(p => ({ ...p, contract_end_date: e.target.value }))} />)}
          {field("Probation End Date", <input className="adm-input" disabled={readOnly} type="date" value={form.probation_end_date || ""} onChange={e => setForm(p => ({ ...p, probation_end_date: e.target.value }))} />)}
          {field("Last Working Date", <input className="adm-input" disabled={readOnly} type="date" value={form.last_working_date || ""} onChange={e => setForm(p => ({ ...p, last_working_date: e.target.value }))} />)}
          {field("Remarks", <textarea className="adm-input" disabled={readOnly} rows={2} value={form.remarks || ""} onChange={e => setForm(p => ({ ...p, remarks: e.target.value }))} />)}
        </div>
        )}
        {formTab === "employment" && renderOffboardingPanel(form.id || null)}

      {formTab === "emergency" && isAdd && (
        <div className="adm-form-grid">
          {field("Name", <input className="adm-input" value={form.emergency_contact_name || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_name: e.target.value }))} />)}
          {field("Relationship", (
            <select className="adm-select" value={form.emergency_contact_relationship || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_relationship: e.target.value }))}>
              <option value="">— Select —</option>
              {(enums.relationship || []).map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          ))}
          {field("Primary Mobile Country Code", countryCodeSelect(form.emergency_contact_mobile_country_code, e => setForm(p => ({ ...p, emergency_contact_mobile_country_code: e.target.value }))))}
          {field("Primary Mobile Number", <input className="adm-input" value={form.emergency_contact_mobile_number || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_mobile_number: e.target.value }))} />)}
          {field("Alternate Mobile Country Code", countryCodeSelect(form.emergency_contact_alternate_mobile_country_code, e => setForm(p => ({ ...p, emergency_contact_alternate_mobile_country_code: e.target.value }))))}
          {field("Alternate Mobile Number", <input className="adm-input" value={form.emergency_contact_alternate_mobile_number || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_alternate_mobile_number: e.target.value }))} />)}
          {field("Email", <input className="adm-input" type="email" value={form.emergency_contact_email || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_email: e.target.value }))} />)}
          {field("Country", <input className="adm-input" value={form.emergency_contact_country || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_country: e.target.value }))} />)}
          {field("Address", <textarea className="adm-input" rows={2} value={form.emergency_contact_address || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_address: e.target.value }))} />)}
          {field("Notes", <textarea className="adm-input" rows={2} value={form.emergency_contact_notes || ""} onChange={e => setForm(p => ({ ...p, emergency_contact_notes: e.target.value }))} />)}
        </div>
      )}

      {formTab === "banking" && renderBankingSection(form.id || null, form.classification)}
      {formTab === "salary" && renderSalarySection(form.id || null)}
      {formTab === "payroll_history" && renderPayrollHistorySection(form.id || null)}
      {formTab === "leave" && renderLeaveSection(form.id || null)}
      {formTab === "loans" && renderLoansSection(form.id || null)}
      {formTab === "assets" && renderAssetsSection(form.id || null)}

      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 16 }}>
        {!readOnly && (isAdd ? (
          <>
            {tabIdx > 0 && (
              <button type="button" className="adm-btn-secondary" onClick={() => setFormTab(enabledTabs[tabIdx - 1].key)}>Back</button>
            )}
            {tabIdx < enabledTabs.length - 1 ? (
              <>
                {/* Reachable from every tab, not just the last one — see saveProgress
                    above for why this exists. Once it succeeds the form is already in
                    real Edit mode, so this button's job here is done from then on. */}
                <button type="button" className="adm-btn-secondary" disabled={savingEmployee} onClick={saveProgress}>
                  {savingEmployee ? "Saving…" : "Save Progress"}
                </button>
                <button type="button" className="adm-submit" style={{ marginTop: 0 }} onClick={() => setFormTab(enabledTabs[tabIdx + 1].key)}>Next</button>
              </>
            ) : (
              <button className="adm-submit" style={{ marginTop: 0 }} disabled={savingEmployee} onClick={onSave}>{savingEmployee ? "Saving…" : submitLabel}</button>
            )}
          </>
        ) : (
          // Banking/Salary have their own dedicated "Save Bank Details" /
          // "Save Salary Structure" buttons within those tabs (separate
          // endpoints) — "Save Changes" only persists the main employee
          // record and does nothing for those two (or for the read-only
          // Payroll History tab), so showing it there too just reads as a
          // confusing duplicate.
          !["banking", "salary", "payroll_history"].includes(formTab) && (
            <button className="adm-submit" style={{ marginTop: 0 }} disabled={savingEmployee} onClick={onSave}>{savingEmployee ? "Saving…" : submitLabel}</button>
          )
        ))}
        <button className="adm-btn-secondary" onClick={() => { setView("list"); setEditingEmp(null); setDupWarning(null); setError(""); }}>
          {readOnly ? "Close" : isAdd ? "Cancel" : "Back to List"}
        </button>
      </div>
    </div>
    );
  };

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" />
      <style>{CSS}</style>
      <header className="adm-topbar">
        <button className="adm-back" onClick={() => navigate("/")} title="Back"><IconArrowLeft /></button>
        <div className="adm-brand">
          <div className="adm-brand-mark">🧑‍💼</div>
          <span className="adm-brand-label">HRMS & Payroll — Employees</span>
        </div>
        <div style={{ marginRight: 8, fontSize: 12, color: "#6080aa" }}>{user?.org_name}</div>
        <div className="adm-avatar" title={user?.name}>{initials}</div>
      </header>

      <div className="adm-tabs">
        <button className="adm-tab" onClick={() => navigate("/hrms/dashboard")}>Dashboard</button>
        <button className="adm-tab active"
                onClick={() => { setView("list"); setEditingEmp(null); setDupWarning(null); setError(""); }}>
          Employees
        </button>
        <button className="adm-tab" onClick={() => navigate("/hrms/payroll")}>Payroll</button>
        <button className="adm-tab" onClick={() => navigate("/hrms/expiry")}>Document Expiry</button>
        <button className="adm-tab" onClick={() => navigate("/hrms/data-quality")}>Data Quality</button>
        <button className="adm-tab" onClick={() => navigate("/hrms/company-documents")}>Company Documents</button>
        <button className="adm-tab" onClick={() => navigate("/hrms/assistant")}>AI Assistant</button>
      </div>

      <div className="adm-main">
        {error && <div className="adm-error">{error}</div>}
        {msg && <div className="adm-toast"><span className="adm-toast-dot" />{msg}</div>}

        {view === "list" && (
          <>
            <div className="adm-card">
              <div className="adm-card-title">🤖 AI Search</div>
              <div className="adm-card-desc" style={{ marginTop: 0 }}>
                Ask for what you need in plain language — name, department, nationality, joining date, bank on file,
                current salary, anything on an employee's profile. Try: <em>"expats who joined this year"</em> or{" "}
                <em>"finance staff with no bank details on file"</em>.
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <input className="adm-input" style={{ flex: 1 }} placeholder="Ask anything about your employees…"
                       value={aiQuery} onChange={e => setAiQuery(e.target.value)}
                       onKeyDown={e => e.key === "Enter" && handleAiSearch()} />
                <button className="adm-submit" disabled={aiSearching || !aiQuery.trim()} onClick={handleAiSearch}>
                  {aiSearching ? "Searching…" : "AI Search"}
                </button>
                {aiResults !== null && (
                  <button className="adm-action-btn" onClick={clearAiSearch}>Clear</button>
                )}
              </div>
            </div>

            <div className="adm-card">
              <div className="adm-card-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>
                  {aiResults !== null
                    ? `AI Search Results (${aiResults.length})`
                    : `All Employees (${employees.length})`}
                </span>
                <button type="button" className="adm-submit" style={{ marginTop: 0 }} onClick={startAddFlow}>+ Create Employee</button>
              </div>

              {loading ? (
                <div>
                  {[0, 1, 2, 3, 4, 5].map(i => (
                    <div className="adm-skeleton-row" key={i}>
                      <div className="adm-skeleton-bar" style={{ width: "70%" }} />
                      <div className="adm-skeleton-bar" style={{ width: "50%" }} />
                      <div className="adm-skeleton-bar" style={{ width: "60%" }} />
                      <div className="adm-skeleton-bar" style={{ width: "45%" }} />
                      <div className="adm-skeleton-bar" style={{ width: "80%" }} />
                    </div>
                  ))}
                </div>
              ) : (aiResults !== null ? aiResults : employees).length === 0 ? (
                <div className="adm-empty">
                  {aiResults !== null
                    ? "No employees matched that search."
                    : 'No employees yet. Click "+ Create Employee" above to create the first one.'}
                </div>
              ) : (
                <div className="adm-table-wrap">
                  <table className="adm-table">
                    <thead>
                      <tr><th>Code</th><th>Name</th><th>Classification</th><th>Status</th><th>Department</th><th>Designation</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                      {(aiResults !== null ? aiResults : employees).map(emp => (
                        <tr key={emp.id}>
                          <td style={{ color: "#0d1a36", fontWeight: 600 }}>{emp.employee_code}</td>
                          <td>{emp.full_name}</td>
                          <td><Badge label={emp.classification} type={emp.classification} colorMap={CLASSIFICATION_COLOR} /></td>
                          <td><Badge label={emp.employment_status} type={emp.employment_status} colorMap={STATUS_COLOR} /></td>
                          <td>{emp.department || "—"}</td>
                          <td>{emp.designation || "—"}</td>
                          <td>
                            <div className="adm-row-actions">
                              <button type="button" className="adm-icon-btn" title="View" onClick={() => startView(emp)}><IconEye /></button>
                              <button type="button" className="adm-icon-btn" title="Edit" onClick={() => startEdit(emp)}><IconEdit /></button>
                              <button type="button" className="adm-icon-btn danger" title="Remove" onClick={() => removeEmployee(emp)}><IconTrash /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}

        {view === "add" && renderForm(newEmp, setNewEmp, () => saveNewEmployee(false), "Create Employee")}
        {(view === "edit" || view === "view") && editingEmp && renderForm(editingEmp, setEditingEmp, saveEditedEmployee, "Save Changes")}
      </div>
    </>
  );
}
